// tslint:disable
import { Injectable } from '@angular/core';

import { DwItem, DwItemDetail, DwQuery, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/************************************************
   Generated with the Devware CAP CLI 4.4.37
   Code Gen Name   PermitsV2
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    MSI/mlt
   Generate On     4/16/2024 3:59:52 PM
************************************************/

export enum PermitsV2MetaDataItemNames {
    ChangeRequest = 'ChangeRequest',
    CodeValue = 'CodeValue',
    EthosCodeValue = 'Ethos_CodeValue',
    EthosCodeValueCustom = 'Ethos_CodeValueCustom',
    EthosJob = 'Ethos_Job',
    EthosJobNumber = 'Ethos_JobNumber',
    EthosJobNumberForecast = 'Ethos_JobNumberForecast',
    EthosJobNumberMembership = 'Ethos_JobNumberMembership',
    EthosJobNumberPhase = 'Ethos_JobNumberPhase',
    EthosJobNumberPriority = 'Ethos_JobNumberPriority',
    EthosJobSite = 'Ethos_JobSite',
    EthosJobSow = 'Ethos_JobSow',
    EthosOpportunity = 'Ethos_Opportunity',
    EthosUser = 'Ethos_User',
    EthosUserDiff = 'Ethos_UserDiff',
    EthosUserSkill = 'Ethos_UserSkill',
    EthosWachterDepartment = 'Ethos_WachterDepartment',
    EthosWachterTeam = 'Ethos_WachterTeam',
    EthosWorkflowStatus = 'Ethos_WorkflowStatus',
    EthosWorkflowStatusSet = 'Ethos_WorkflowStatusSet',
    InspectionResult = 'InspectionResult',
    InspectionStatus = 'InspectionStatus',
    NoteType = 'NoteType',
    Permits2AccessControl = 'permits2_AccessControl',
    Permits2Inspection = 'permits2_Inspection',
    Permits2Permit = 'permits2_Permit',
    Permits2PermitPermitType = 'permits2_PermitPermitType',
    Permits2PermitStatus = 'permits2_PermitStatus',
    Permits2RequiredCable = 'permits2_RequiredCable',
    Permits2RoInspections = 'permits2_roInspections',
    Permits2RoPermits = 'permits2_roPermits',
    RoEthosUser = 'roEthos_User',
    RoEthosUserOriginal = 'roEthos_UserOriginal',
    RoPermitsBySubordinates = 'roPermitsBySubordinates',
    StageAuditLog = 'StageAuditLog',
}

export enum PermitsV2MetaDataLookups {
    AccessControlAllItems = 2846,
    ActiveJobNumberByOpportunity = 2934,
    ChangeRequestAllItems = 2902,
    CodeValueAccessControl = 2811,
    CodeValueAccessControlAdditionalOptions = 1849,
    CodeValueCCTVTypesOfInstall = 1851,
    CodeValueCompanyLicenseStatus = 2877,
    CodeValueDifferentTypeOfElectrical = 1846,
    CodeValueElectricalNewWorkType = 1848,
    CodeValueFireAlarmDemoOrInstall = 1850,
    CodeValueInspectionState = 1866,
    CodeValueInspectionTimeOfDay = 1863,
    CodeValueLicenseStatus = 1467,
    CodeValueMORSubTypeByIssueType = 1513,
    CodeValuePassFail = 1867,
    CodeValuePerformWork = 1803,
    CodeValuePermitCableType = 1799,
    CodeValuePermitRequestAddAction = 2865,
    CodeValuePermitRequestElectricalOutletType = 1845,
    CodeValuePermitRequestType = 1798,
    CodeValuePermitStatus = 1801,
    CodeValueTypesOfElectrical = 1847,
    CodeValueAccidentType = 1541,
    CodeValueAccidentTypeWorkplace = 1648,
    CodeValueAirportPlan = 1596,
    CodeValueAtFault = 1542,
    CodeValueBodyPart = 1684,
    CodeValueBodySide = 1685,
    CodeValueBusinessPlanReviewAccidentType = 1587,
    CodeValueClaimStatus = 1544,
    CodeValueEmployeeTrainingNeeded = 1525,
    CodeValueEmployeeTrainingNeededConclusion = 1532,
    CodeValueEmployeeTrainingNeededStatus = 1534,
    CodeValueEmsWorkStatus = 1638,
    CodeValueEquipmentDelivery = 1453,
    CodeValueEthosJobNumberType = 2868,
    CodeValueEthosSkill = 2840,
    CodeValueFiveStarRatingValue = 1616,
    CodeValueInjuryType = 1683,
    CodeValueInspectionResults = 1869,
    CodeValueInsuranceCompany = 1545,
    CodeValueJobType = 2821,
    CodeValueLodgingPlan = 1598,
    CodeValueMemoOfRecordIssueSubTypeAll = 1515,
    CodeValueMemoOfRecordConclusion = 1511,
    CodeValueMemoOfRecordEmployeeType = 1510,
    CodeValueMemoOfRecordIssueType = 1512,
    CodeValueMORStatus = 1517,
    CodeValuePayJobChangeDepartmentRole = 1485,
    CodeValuePayJobChangeStatus = 1481,
    CodeValuePayJobChangeType = 1486,
    CodeValuePermitTeam = 1731,
    CodeValuePermitType = 1726,
    CodeValuePlenumOrRiser = 1727,
    CodeValueTechType = 1586,
    CodeValueTermResignType = 1487,
    CodeValueTransportationPlan = 1597,
    CodeValueTravelMode = 1595,
    CodeValueTravelRequestStatus = 1601,
    CodeValueTravelType = 1599,
    CodeValueVechicleRepaired = 1543,
    CodeValueWorkerType = 1792,
    CodeValueWorkersCompClaimStatus = 2862,
    CodeValueWorksiteType = 1647,
    EmployeesByDeptIncTrainees = 2812,
    EthosInvoiceDeliveryType = 1707,
    EthosUserTypeCodeValue = 1690,
    EthosCodeValueAllItems = 1631,
    EthosCodeValueCustomAllItems = 1733,
    EthosJobActiveOnly = 2841,
    EthosJobAllItems = 1716,
    EthosJobNumberActiveOnlyForKickoff = 1750,
    EthosJobNumberEJNPJNFJN = 2869,
    EthosJobNumberAllItems = 1378,
    EthosJobNumberEndDate = 1504,
    EthosJobNumberForecastAllItems = 1377,
    EthosJobNumberMembershipAllItems = 2867,
    EthosJobNumberPhaseAllItems = 1588,
    EthosJobNumberPriorityAllItems = 2866,
    EthosJobSiteAllItems = 1717,
    EthosJobSowAllItems = 1718,
    EthosOpportunityAllItems = 1793,
    EthosUserBySupervisor = 1758,
    EthosUserBySupervisorPlusIndirect = 1773,
    EthosUserByUsersDepartment = 1582,
    ETHOSUSERNSPLBUOfficeActiveEmployees = 1696,
    ETHOSUSERWachterEmployeesActiveEmployees = 1464,
    EthosUserAllItems = 1416,
    EthosUserDiffAllItems = 1623,
    EthosUserEmployeeGroups = 2858,
    EthosUserSkillAllItems = 1413,
    EthosWachterDepartmentAllItems = 1391,
    EthosWachterTeamDivisionDepartment = 1496,
    EthosWachterTeamNSPLBU = 1709,
    EthosWachterTeamAllItems = 1415,
    EthosWachterTeamAllItemsWithDivision = 1860,
    EthosWorkflowStatusUserStatus = 1640,
    EthosWorkflowStatusAllItems = 1633,
    EthosWorkflowStatusSetAllItems = 1632,
    InspectionAllItems = 2848,
    InspectionStatusV2 = 2855,
    InspectionResultAllItems = 2850,
    InspectionStatusAllItems = 2851,
    JobByOpportunityId = 1794,
    JobLookupWithJobNumber = 1729,
    JobSiteSiteInfo = 1788,
    JobNumberActive = 1872,
    JobNumberToCustJobName = 2870,
    JobSowScopeOfWorkAndSiteInfo = 1725,
    NoteTypeAllItems = 1839,
    OpportunityByCustomer = 2921,
    OverheadJobNumbers = 1589,
    PermitJobTypeLookup = 1811,
    PermitRequestJobTypeLookupNoJobNumber = 1873,
    PermitStatusV2 = 2854,
    PermitV2AllItems = 2842,
    PermitPermitTypeAllItems = 2843,
    PermitStatusAllItems = 2849,
    Permitv2JobTypeLookupNoJobNumber = 2845,
    PlenumRiseOutdoor = 1796,
    ProjectKickoffBillingFrequency = 2923,
    ProjectKickoffBillingType = 2922,
    ProjectKickoffJobNumberFromOpportunity = 2931,
    ProjectKickoffOpportunityWCustomer = 2927,
    RequiredCableAllItems = 2847,
    RoEthosUserActiveOnly = 2837,
    RoEthosUserAllActiveThenInactive = 2889,
    RoEthosUserAllItems = 1422,
    RoEthosUserOriginalAllItems = 1753,
    RoInspectionsAllItems = 2852,
    RoPermitsAllItems = 2844,
    RoPermitsBySubordinatesAllItems = 2863,
    StageAuditLogAllItems = 2864,
    TrustCodeValueAllItems = 1388,
    WachterDivisions = 1858,
    WachterTeamByDepartment = 1768,
    WJIDByJobNumber = 1871,
    WorkflowStatusJobNumberStatus = 1751,
    WorkflowStatusOpportunityStatus = 2925,
    WorkflowStatusPermitStatusDONOTUSE = 1728,
    WorkflowStatusProjectStatus = 2926,
    WorkflowStatusUserStatus = 2823,
}

@Injectable({
    providedIn: 'root'
})
export class PermitsV2MetaDataService {

    Permits2AccessControl : Permits2AccessControlMetaData = new Permits2AccessControlMetaData();
    ChangeRequest : ChangeRequestMetaData = new ChangeRequestMetaData();
    CodeValue : CodeValueMetaData = new CodeValueMetaData();
    EthosCodeValue : EthosCodeValueMetaData = new EthosCodeValueMetaData();
    EthosCodeValueCustom : EthosCodeValueCustomMetaData = new EthosCodeValueCustomMetaData();
    EthosJob : EthosJobMetaData = new EthosJobMetaData();
    EthosJobNumber : EthosJobNumberMetaData = new EthosJobNumberMetaData();
    EthosJobNumberForecast : EthosJobNumberForecastMetaData = new EthosJobNumberForecastMetaData();
    EthosJobNumberMembership : EthosJobNumberMembershipMetaData = new EthosJobNumberMembershipMetaData();
    EthosJobNumberPhase : EthosJobNumberPhaseMetaData = new EthosJobNumberPhaseMetaData();
    EthosJobNumberPriority : EthosJobNumberPriorityMetaData = new EthosJobNumberPriorityMetaData();
    EthosJobSite : EthosJobSiteMetaData = new EthosJobSiteMetaData();
    EthosJobSow : EthosJobSowMetaData = new EthosJobSowMetaData();
    EthosOpportunity : EthosOpportunityMetaData = new EthosOpportunityMetaData();
    EthosUser : EthosUserMetaData = new EthosUserMetaData();
    EthosUserDiff : EthosUserDiffMetaData = new EthosUserDiffMetaData();
    EthosUserSkill : EthosUserSkillMetaData = new EthosUserSkillMetaData();
    EthosWachterDepartment : EthosWachterDepartmentMetaData = new EthosWachterDepartmentMetaData();
    EthosWachterTeam : EthosWachterTeamMetaData = new EthosWachterTeamMetaData();
    EthosWorkflowStatus : EthosWorkflowStatusMetaData = new EthosWorkflowStatusMetaData();
    EthosWorkflowStatusSet : EthosWorkflowStatusSetMetaData = new EthosWorkflowStatusSetMetaData();
    Permits2Inspection : Permits2InspectionMetaData = new Permits2InspectionMetaData();
    InspectionResult : InspectionResultMetaData = new InspectionResultMetaData();
    InspectionStatus : InspectionStatusMetaData = new InspectionStatusMetaData();
    NoteType : NoteTypeMetaData = new NoteTypeMetaData();
    Permits2Permit : Permits2PermitMetaData = new Permits2PermitMetaData();
    Permits2PermitPermitType : Permits2PermitPermitTypeMetaData = new Permits2PermitPermitTypeMetaData();
    Permits2PermitStatus : Permits2PermitStatusMetaData = new Permits2PermitStatusMetaData();
    Permits2RequiredCable : Permits2RequiredCableMetaData = new Permits2RequiredCableMetaData();
    RoEthosUser : RoEthosUserMetaData = new RoEthosUserMetaData();
    RoEthosUserOriginal : RoEthosUserOriginalMetaData = new RoEthosUserOriginalMetaData();
    Permits2RoInspections : Permits2RoInspectionsMetaData = new Permits2RoInspectionsMetaData();
    Permits2RoPermits : Permits2RoPermitsMetaData = new Permits2RoPermitsMetaData();
    RoPermitsBySubordinates : RoPermitsBySubordinatesMetaData = new RoPermitsBySubordinatesMetaData();
    StageAuditLog : StageAuditLogMetaData = new StageAuditLogMetaData();
}

// Generated Classes for MetaData service
export class Permits2AccessControlMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_AccessControl.';

    constructor() {
        this.ItemDetail.ItemId=2780;
        this.ItemDetail.ItemName='permits2_AccessControl';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AccessControlId : string = this.i + 'AccessControlId';
    AccessControlCv : string = this.i + 'AccessControlCv';
    Quantity : string = this.i + 'Quantity';
    Description : string = this.i + 'Description';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';

    Relations = {
            /** Relation: Trust Code Value - Access Control Cv */
            CodeValueByAccessControlCv : {
                RelationName: 'CodeValue|permits2_AccessControl|AccessControlCv',
                FieldPrefix: 'AccessControlCvCodeValue',
                PropertyName: 'AccessControlCvCodeValue'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'permits2_Permit|permits2_AccessControl|PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_AccessControl|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_AccessControl|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
    };
}

export class ChangeRequestMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ChangeRequest.';

    constructor() {
        this.ItemDetail.ItemId=3411;
        this.ItemDetail.ItemName='ChangeRequest';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ChangeRequestId : string = this.i + 'ChangeRequestId';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    NoteId : string = this.i + 'NoteId';
    InProgress : string = this.i + 'InProgress';
    InitialPermitStatusId : string = this.i + 'InitialPermitStatusId';
    CompletedByUserId : string = this.i + 'CompletedByUserId';
    CompletedOnDateTime : string = this.i + 'CompletedOnDateTime';

    Relations = {
            /** Relation: Permit Status - Initial Permit Status */
            Permits2PermitStatusByInitialPermitStatusId : {
                RelationName: 'permits2_PermitStatus|ChangeRequest|InitialPermitStatusId',
                FieldPrefix: 'InitialPermits2PermitStatus',
                PropertyName: 'InitialPermits2PermitStatus'
            },
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|ChangeRequest|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Completed By User */
            EthosUserByCompletedByUserId : {
                RelationName: 'Ethos_User|ChangeRequest|CompletedByUserId',
                FieldPrefix: 'CompletedByEthosUser',
                PropertyName: 'CompletedByEthosUser'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'ChangeRequest|permits2_Permit|ChangeRequestId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
    };
}

export class CodeValueMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CodeValue.';

    constructor() {
        this.ItemDetail.ItemId=2385;
        this.ItemDetail.ItemName='CodeValue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueId : string = this.i + 'CodeValueId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Access Control - Access Control Cv - Many */
            Permits2AccessControlByAccessControlCv : {
                RelationName: 'CodeValue|permits2_AccessControl|AccessControlCv',
                FieldPrefix: 'AccessControlCvPermits2AccessControl',
                PropertyName: 'AccessControlCvPermits2AccessControl'
            },
            /** Relation: Inspection - Preferred Time Of Day Cv - Many */
            Permits2InspectionByPreferredTimeOfDayCv : {
                RelationName: 'CodeValue|permits2_Inspection|PreferredTimeOfDayCv',
                FieldPrefix: 'PreferredTimeOfDayCvPermits2Inspection',
                PropertyName: 'PreferredTimeOfDayCvPermits2Inspection'
            },
            /** Relation: Permit - Permit Request Type Cv - Many */
            Permits2PermitByPermitRequestTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|PermitRequestTypeCv',
                FieldPrefix: 'PermitRequestTypeCvPermits2Permit',
                PropertyName: 'PermitRequestTypeCvPermits2Permit'
            },
            /** Relation: Permit - C C T V Install Type Cv - Many */
            Permits2PermitByCCTVInstallTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|CCTVInstallTypeCv',
                FieldPrefix: 'CCTVInstallTypeCvPermits2Permit',
                PropertyName: 'CCTVInstallTypeCvPermits2Permit'
            },
            /** Relation: Permit - Electrical Different Type Cv - Many */
            Permits2PermitByElectricalDifferentTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|ElectricalDifferentTypeCv',
                FieldPrefix: 'ElectricalDifferentTypeCvPermits2Permit',
                PropertyName: 'ElectricalDifferentTypeCvPermits2Permit'
            },
            /** Relation: Permit - Electrical Outlet Type Cv - Many */
            Permits2PermitByElectricalOutletTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|ElectricalOutletTypeCv',
                FieldPrefix: 'ElectricalOutletTypeCvPermits2Permit',
                PropertyName: 'ElectricalOutletTypeCvPermits2Permit'
            },
            /** Relation: Permit - Electrical Work Type Cv - Many */
            Permits2PermitByElectricalWorkTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|ElectricalWorkTypeCv',
                FieldPrefix: 'ElectricalWorkTypeCvPermits2Permit',
                PropertyName: 'ElectricalWorkTypeCvPermits2Permit'
            },
            /** Relation: Permit - Fire Alarm Demo Install Cv - Many */
            Permits2PermitByFireAlarmDemoInstallCv : {
                RelationName: 'CodeValue|permits2_Permit|FireAlarmDemoInstallCv',
                FieldPrefix: 'FireAlarmDemoInstallCvPermits2Permit',
                PropertyName: 'FireAlarmDemoInstallCvPermits2Permit'
            },
            /** Relation: Required Cable - Cable Type Cv - Many */
            Permits2RequiredCableByCableTypeCv : {
                RelationName: 'CodeValue|permits2_RequiredCable|CableTypeCv',
                FieldPrefix: 'CableTypeCvPermits2RequiredCable',
                PropertyName: 'CableTypeCvPermits2RequiredCable'
            },
    };
}

export class EthosCodeValueMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_CodeValue.';

    constructor() {
        this.ItemDetail.ItemId=2579;
        this.ItemDetail.ItemName='Ethos_CodeValue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueId : string = this.i + 'CodeValueId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';
    ImagePath : string = this.i + 'ImagePath';

    Relations = {
            /** Relation: Ethos Job - Job Category Cv - Many */
            EthosJobByJobCategoryCv : {
                RelationName: 'Ethos_CodeValue|Ethos_Job|JobCategoryCv',
                FieldPrefix: 'JobCategoryCvEthosJob',
                PropertyName: 'JobCategoryCvEthosJob'
            },
            /** Relation: Job Number - Invoice Delivery Type C V - Many */
            EthosJobNumberByInvoiceDeliveryTypeCV : {
                RelationName: 'Ethos_CodeValue|Ethos_JobNumber|InvoiceDeliveryTypeCV',
                FieldPrefix: 'InvoiceDeliveryTypeCVEthosJobNumber',
                PropertyName: 'InvoiceDeliveryTypeCVEthosJobNumber'
            },
            /** Relation: Job Number - Forecast Status Cv - Many */
            EthosJobNumberByForecastStatusCv : {
                RelationName: 'Ethos_CodeValue|Ethos_JobNumber|ForecastStatusCv',
                FieldPrefix: 'ForecastStatusCvEthosJobNumber',
                PropertyName: 'ForecastStatusCvEthosJobNumber'
            },
            /** Relation: Job Number - Job Number Type Cv - Many */
            EthosJobNumberByJobNumberTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_JobNumber|JobNumberTypeCv',
                FieldPrefix: 'JobNumberTypeCvEthosJobNumber',
                PropertyName: 'JobNumberTypeCvEthosJobNumber'
            },
            /** Relation: Ethos User - User Type Cv - Many */
            EthosUserByUserTypeCv : {
                RelationName: 'Ethos_User|Ethos_CodeValue|UserTypeCv',
                FieldPrefix: 'UserTypeCvEthosUser',
                PropertyName: 'UserTypeCvEthosUser'
            },
            /** Relation: Ethos User - Resource Group Cv - Many */
            EthosUserByResourceGroupCv : {
                RelationName: 'Ethos_CodeValue|Ethos_User|ResourceGroupCv',
                FieldPrefix: 'ResourceGroupCvEthosUser',
                PropertyName: 'ResourceGroupCvEthosUser'
            },
            /** Relation: User Skill - Skill Cv - Many */
            EthosUserSkillBySkillCv : {
                RelationName: 'Ethos_CodeValue|Ethos_UserSkill|SkillCv',
                FieldPrefix: 'SkillCvEthosUserSkill',
                PropertyName: 'SkillCvEthosUserSkill'
            },
            /** Relation: Wachter Department - Department Type Cv - Many */
            EthosWachterDepartmentByDepartmentTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_WachterDepartment|DepartmentTypeCv',
                FieldPrefix: 'DepartmentTypeCvEthosWachterDepartment',
                PropertyName: 'DepartmentTypeCvEthosWachterDepartment'
            },
            /** Relation: Wachter Team - Team Type Cv - Many */
            EthosWachterTeamByTeamTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_WachterTeam|TeamTypeCv',
                FieldPrefix: 'TeamTypeCvEthosWachterTeam',
                PropertyName: 'TeamTypeCvEthosWachterTeam'
            },
            /** Relation: Permit - Permit Team Cv - Many */
            Permits2PermitByPermitTeamCv : {
                RelationName: 'Ethos_CodeValue|permits2_Permit|PermitTeamCv',
                FieldPrefix: 'PermitTeamCvPermits2Permit',
                PropertyName: 'PermitTeamCvPermits2Permit'
            },
            /** Relation: Permit - Plenum Riser Cv - Many */
            Permits2PermitByPlenumRiserCv : {
                RelationName: 'Ethos_CodeValue|permits2_Permit|PlenumRiserCv',
                FieldPrefix: 'PlenumRiserCvPermits2Permit',
                PropertyName: 'PlenumRiserCvPermits2Permit'
            },
            /** Relation: Permit Permit Type - Permit Type Cv - Many */
            Permits2PermitPermitTypeByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|permits2_PermitPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermits2PermitPermitType',
                PropertyName: 'PermitTypeCvPermits2PermitPermitType'
            },
            /** Relation: Required Cable - Permit Type Cv - Many */
            Permits2RequiredCableByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|permits2_RequiredCable|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermits2RequiredCable',
                PropertyName: 'PermitTypeCvPermits2RequiredCable'
            },
            /** Relation: Ro Ethos User - Resource Group Cv - Many */
            RoEthosUserByResourceGroupCv : {
                RelationName: 'Ethos_CodeValue|roEthos_User|ResourceGroupCv',
                FieldPrefix: 'ResourceGroupCvRoEthosUser',
                PropertyName: 'ResourceGroupCvRoEthosUser'
            },
            /** Relation: Ro Ethos User - User Type Cv - Many */
            RoEthosUserByUserTypeCv : {
                RelationName: 'Ethos_CodeValue|roEthos_User|UserTypeCv',
                FieldPrefix: 'UserTypeCvRoEthosUser',
                PropertyName: 'UserTypeCvRoEthosUser'
            },
    };
}

export class EthosCodeValueCustomMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_CodeValueCustom.';

    constructor() {
        this.ItemDetail.ItemId=2643;
        this.ItemDetail.ItemName='Ethos_CodeValueCustom';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueCustomId : string = this.i + 'CodeValueCustomId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
    };
}

export class EthosJobMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_Job.';

    constructor() {
        this.ItemDetail.ItemId=2635;
        this.ItemDetail.ItemName='Ethos_Job';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobId : string = this.i + 'JobId';
    JobNumberId : string = this.i + 'JobNumberId';
    JobEtcDateTime : string = this.i + 'JobEtcDateTime';
    LookUpKey : string = this.i + 'LookUpKey';
    JobStatusWs : string = this.i + 'JobStatusWs';
    JobStartDateTime : string = this.i + 'JobStartDateTime';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    JobDueDateTime : string = this.i + 'JobDueDateTime';
    CompletedByUserId : string = this.i + 'CompletedByUserId';
    CompletedByDateTime : string = this.i + 'CompletedByDateTime';
    IsTechOnSite : string = this.i + 'IsTechOnSite';
    JobCategoryCv : string = this.i + 'JobCategoryCv';
    JobNumberPriorityId : string = this.i + 'JobNumberPriorityId';

    Relations = {
            /** Relation: Ethos Code Value - Job Category */
            EthosCodeValueByJobCategoryCv : {
                RelationName: 'Ethos_CodeValue|Ethos_Job|JobCategoryCv',
                FieldPrefix: 'JobCategoryCvEthosCodeValue',
                PropertyName: 'JobCategoryCvEthosCodeValue'
            },
            /** Relation: Ethos Job Site */
            EthosJobSiteByJobId : {
                RelationName: 'Job Site -> Job',
                FieldPrefix: 'EthosJobSiteJobId',
                PropertyName: 'EthosJobSiteJobId'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_Job|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos Job Number Priority */
            EthosJobNumberPriority : {
                RelationName: 'Ethos_JobNumberPriority|Ethos_Job|JobNumberPriorityId',
                FieldPrefix: 'EthosJobNumberPriority',
                PropertyName: 'EthosJobNumberPriority'
            },
            /** Relation: Ethos User - Completed By User */
            EthosUserByCompletedByUserId : {
                RelationName: 'Ethos_User|Ethos_Job|CompletedByUserId',
                FieldPrefix: 'CompletedByEthosUser',
                PropertyName: 'CompletedByEthosUser'
            },
            /** Relation: Ethos Workflow Status - Job Status */
            EthosWorkflowStatusByJobStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_Job|JobStatusWs',
                FieldPrefix: 'JobStatusWsEthosWorkflowStatus',
                PropertyName: 'JobStatusWsEthosWorkflowStatus'
            },
            /** Relation: Job Number */
            EthosJobNumberByJobNumberId : {
                RelationName: 'JobToJobNumber',
                FieldPrefix: 'EthosJobNumberJobNumberId',
                PropertyName: 'EthosJobNumberJobNumberId'
            },
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_Job|Ethos_JobSite|JobId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
            /** Relation: Ethos Job Sow */
            EthosJobSow : {
                RelationName: 'Ethos_Job|Ethos_JobSow|JobId',
                FieldPrefix: 'EthosJobSow',
                PropertyName: 'EthosJobSow'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'Ethos_Job|permits2_Permit|JobId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
    };
}

export class EthosJobNumberMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumber.';

    constructor() {
        this.ItemDetail.ItemId=2375;
        this.ItemDetail.ItemName='Ethos_JobNumber';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumberStatusWs : string = this.i + 'JobNumberStatusWs';
    JobNumberStatus : string = this.i + 'JobNumberStatus';
    JobNumber : string = this.i + 'JobNumber';
    CustomerId : string = this.i + 'CustomerId';
    JobName : string = this.i + 'JobName';
    EstimatedStartDate : string = this.i + 'EstimatedStartDate';
    EstimatedEndDate : string = this.i + 'EstimatedEndDate';
    ProjectMgr1UserId : string = this.i + 'ProjectMgr1UserId';
    ProjectMgr2UserId : string = this.i + 'ProjectMgr2UserId';
    AsstProjectMgrUserId : string = this.i + 'AsstProjectMgrUserId';
    SeniorMgrUserId : string = this.i + 'SeniorMgrUserId';
    LeadTech1UserId : string = this.i + 'LeadTech1UserId';
    LeadTech2UserId : string = this.i + 'LeadTech2UserId';
    InvoiceApproval1UserId : string = this.i + 'InvoiceApproval1UserId';
    InvoiceApproval2UserId : string = this.i + 'InvoiceApproval2UserId';
    ForecastStatusCv : string = this.i + 'ForecastStatusCv';
    ForecastStatus : string = this.i + 'ForecastStatus';
    WachterTeamId : string = this.i + 'WachterTeamId';
    CustomerName : string = this.i + 'CustomerName';
    CustomerShortName : string = this.i + 'CustomerShortName';
    BillingInstructions : string = this.i + 'BillingInstructions';
    ChangeOrderProcessInstructions : string = this.i + 'ChangeOrderProcessInstructions';
    PartialBilling : string = this.i + 'PartialBilling';
    FinalInvoiceDate : string = this.i + 'FinalInvoiceDate';
    InvoiceDeliveryTypeData : string = this.i + 'InvoiceDeliveryTypeData';
    InvoiceDeliveryTypeCV : string = this.i + 'InvoiceDeliveryTypeCV';
    OpportunityId : string = this.i + 'OpportunityId';
    EndCustomerId : string = this.i + 'EndCustomerId';
    LookUpKey : string = this.i + 'LookUpKey';
    IsDeleted : string = this.i + 'IsDeleted';
    JobNumberTypeCv : string = this.i + 'JobNumberTypeCv';

    Relations = {
            /** Relation: Ethos Code Value - Invoice Delivery Type */
            EthosCodeValueByInvoiceDeliveryTypeCV : {
                RelationName: 'Ethos_CodeValue|Ethos_JobNumber|InvoiceDeliveryTypeCV',
                FieldPrefix: 'InvoiceDeliveryTypeCVEthosCodeValue',
                PropertyName: 'InvoiceDeliveryTypeCVEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Forecast Status Cv */
            EthosCodeValueByForecastStatusCv : {
                RelationName: 'Ethos_CodeValue|Ethos_JobNumber|ForecastStatusCv',
                FieldPrefix: 'ForecastStatusCvEthosCodeValue',
                PropertyName: 'ForecastStatusCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Job Number Type */
            EthosCodeValueByJobNumberTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_JobNumber|JobNumberTypeCv',
                FieldPrefix: 'JobNumberTypeCvEthosCodeValue',
                PropertyName: 'JobNumberTypeCvEthosCodeValue'
            },
            /** Relation: Ethos Job */
            EthosJobByJobNumberId : {
                RelationName: 'JobToJobNumber',
                FieldPrefix: 'EthosJobJobNumberId',
                PropertyName: 'EthosJobJobNumberId'
            },
            /** Relation: Ethos Opportunity */
            EthosOpportunity : {
                RelationName: 'Opportunity-JobNumber',
                FieldPrefix: 'EthosOpportunity',
                PropertyName: 'EthosOpportunity'
            },
            /** Relation: Ethos User - Project Mgr1 User */
            EthosUserByProjectMgr1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|ProjectMgr1UserId',
                FieldPrefix: 'ProjectMgr1EthosUser',
                PropertyName: 'ProjectMgr1EthosUser'
            },
            /** Relation: Ethos User - Project Mgr2 User */
            EthosUserByProjectMgr2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|ProjectMgr2UserId',
                FieldPrefix: 'ProjectMgr2EthosUser',
                PropertyName: 'ProjectMgr2EthosUser'
            },
            /** Relation: Ethos User - Asst Project Mgr User */
            EthosUserByAsstProjectMgrUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|AsstProjectMgrUserId',
                FieldPrefix: 'AsstProjectMgrEthosUser',
                PropertyName: 'AsstProjectMgrEthosUser'
            },
            /** Relation: Ethos User - Senior Mgr User */
            EthosUserBySeniorMgrUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|SeniorMgrUserId',
                FieldPrefix: 'SeniorMgrEthosUser',
                PropertyName: 'SeniorMgrEthosUser'
            },
            /** Relation: Ethos User - Lead Tech1 User */
            EthosUserByLeadTech1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|LeadTech1UserId',
                FieldPrefix: 'LeadTech1EthosUser',
                PropertyName: 'LeadTech1EthosUser'
            },
            /** Relation: Ethos User - Lead Tech2 User */
            EthosUserByLeadTech2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|LeadTech2UserId',
                FieldPrefix: 'LeadTech2EthosUser',
                PropertyName: 'LeadTech2EthosUser'
            },
            /** Relation: Ethos User - Invoice Approval1 User */
            EthosUserByInvoiceApproval1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|InvoiceApproval1UserId',
                FieldPrefix: 'InvoiceApproval1EthosUser',
                PropertyName: 'InvoiceApproval1EthosUser'
            },
            /** Relation: Ethos User - Invoice Approval2 User */
            EthosUserByInvoiceApproval2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|InvoiceApproval2UserId',
                FieldPrefix: 'InvoiceApproval2EthosUser',
                PropertyName: 'InvoiceApproval2EthosUser'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'JobNumber|WachterTeam|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Ethos Workflow Status - Job Number Status */
            EthosWorkflowStatusByJobNumberStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_JobNumber|JobNumberStatusWs',
                FieldPrefix: 'JobNumberStatusWsEthosWorkflowStatus',
                PropertyName: 'JobNumberStatusWsEthosWorkflowStatus'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_JobNumber|Ethos_Job|JobNumberId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
            /** Relation: Job Number Forecast */
            EthosJobNumberForecast : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberForecast|JobNumberId',
                FieldPrefix: 'EthosJobNumberForecast',
                PropertyName: 'EthosJobNumberForecast'
            },
            /** Relation: Ethos Job Number Membership */
            EthosJobNumberMembership : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberMembership|JobNumberId',
                FieldPrefix: 'EthosJobNumberMembership',
                PropertyName: 'EthosJobNumberMembership'
            },
            /** Relation: Ethos Job Number Phase */
            EthosJobNumberPhase : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberPhase|JobNumberId',
                FieldPrefix: 'EthosJobNumberPhase',
                PropertyName: 'EthosJobNumberPhase'
            },
            /** Relation: Ethos Job Number Priority */
            EthosJobNumberPriority : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberPriority|JobNumberId',
                FieldPrefix: 'EthosJobNumberPriority',
                PropertyName: 'EthosJobNumberPriority'
            },
            /** Relation: Ethos User - Project Mgr1 User - Many */
            EthosUserByUserId : {
                RelationName: 'JobNumber->ProjectManager',
                FieldPrefix: 'UserIdEthosUser',
                PropertyName: 'UserIdEthosUser'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_JobNumber|Ethos_WachterDepartment|JobNumberId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Wachter Team - Overhead - Many */
            EthosWachterTeamByOverheadJobNumberId : {
                RelationName: 'Ethos_JobNumber|Ethos_WachterTeam|OverheadJobNumberId',
                FieldPrefix: 'OverheadEthosWachterTeam',
                PropertyName: 'OverheadEthosWachterTeam'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'Ethos_JobNumber|permits2_Permit|JobNumberId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Ro Permits */
            Permits2RoPermits : {
                RelationName: 'roPermits|Ethos_JobNumber|JobNumberId',
                FieldPrefix: 'Permits2roPermits',
                PropertyName: 'Permits2roPermits'
            },
            /** Relation: Ro Permits - Job Num - Many */
            Permits2RoPermitsByJobNumJobNumberId : {
                RelationName: 'roPermits|Ethos_JobNumber|JobNumJobNumberId',
                FieldPrefix: 'JobNumPermits2roPermits',
                PropertyName: 'JobNumPermits2roPermits'
            },
    };
}

export class EthosJobNumberForecastMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberForecast.';

    constructor() {
        this.ItemDetail.ItemId=2374;
        this.ItemDetail.ItemName='Ethos_JobNumberForecast';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberForecastId : string = this.i + 'JobNumberForecastId';
    JobNumberId : string = this.i + 'JobNumberId';
    YeProjectedCosts : string = this.i + 'YeProjectedCosts';
    YeProjectedRevenue : string = this.i + 'YeProjectedRevenue';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedBy : string = this.i + 'CreatedBy';
    ModifiedBy : string = this.i + 'ModifiedBy';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    Notes : string = this.i + 'Notes';
    NoteAgingOverSixtyDays : string = this.i + 'NoteAgingOverSixtyDays';
    NoteOverUnderBilling : string = this.i + 'NoteOverUnderBilling';
    NoteLowForecastedGpm : string = this.i + 'NoteLowForecastedGpm';
    NoteChangedGpm : string = this.i + 'NoteChangedGpm';
    AXIntegrationID : string = this.i + 'AXIntegrationID';
    TotalForecastRevenue : string = this.i + 'TotalForecastRevenue';
    TotalForecastCost : string = this.i + 'TotalForecastCost';
    LookUpKey : string = this.i + 'LookUpKey';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberForecast|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedBy : {
                RelationName: 'Ethos_User|Ethos_JobNumberForecast|CreatedBy',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedBy : {
                RelationName: 'Ethos_User|Ethos_JobNumberForecast|ModifiedBy',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
    };
}

export class EthosJobNumberMembershipMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberMembership.';

    constructor() {
        this.ItemDetail.ItemId=2794;
        this.ItemDetail.ItemName='Ethos_JobNumberMembership';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberMembershipId : string = this.i + 'JobNumberMembershipId';
    UserId : string = this.i + 'UserId';
    JobNumberId : string = this.i + 'JobNumberId';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberMembership|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_JobNumberMembership|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
    };
}

export class EthosJobNumberPhaseMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberPhase.';

    constructor() {
        this.ItemDetail.ItemId=2552;
        this.ItemDetail.ItemName='Ethos_JobNumberPhase';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberPhaseId : string = this.i + 'JobNumberPhaseId';
    JobNumberId : string = this.i + 'JobNumberId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsActive : string = this.i + 'IsActive';
    IsVisible : string = this.i + 'IsVisible';
    IsOnSite : string = this.i + 'IsOnSite';
    IsEstimate : string = this.i + 'IsEstimate';
    JobNumberPhaseStatusWs : string = this.i + 'JobNumberPhaseStatusWs';
    WorkflowStatusDisplay : string = this.i + 'WorkflowStatusDisplay';
    LookUpKey : string = this.i + 'LookUpKey';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberPhase|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos Workflow Status - Job Number Phase Status */
            EthosWorkflowStatusByJobNumberPhaseStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_JobNumberPhase|JobNumberPhaseStatusWs',
                FieldPrefix: 'JobNumberPhaseStatusWsEthosWorkflowStatus',
                PropertyName: 'JobNumberPhaseStatusWsEthosWorkflowStatus'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_JobNumberPhase|Ethos_WachterDepartment|JobNumberPhaseId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Wachter Team - Job Number Phase - Many */
            EthosWachterTeamByOverheadJobNumberPhaseId : {
                RelationName: 'Ethos_JobNumberPhase|Ethos_WachterTeam|OverheadJobNumberPhaseId',
                FieldPrefix: 'OverheadEthosWachterTeam',
                PropertyName: 'OverheadEthosWachterTeam'
            },
    };
}

export class EthosJobNumberPriorityMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberPriority.';

    constructor() {
        this.ItemDetail.ItemId=2792;
        this.ItemDetail.ItemName='Ethos_JobNumberPriority';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberPriorityId : string = this.i + 'JobNumberPriorityId';
    JobNumberId : string = this.i + 'JobNumberId';
    PriorityName : string = this.i + 'PriorityName';
    IsDeleted : string = this.i + 'IsDeleted';
    ResponseTimeInHours : string = this.i + 'ResponseTimeInHours';
    StraightHourlyBillingRate : string = this.i + 'StraightHourlyBillingRate';
    OvertimeHourlyBillingRate : string = this.i + 'OvertimeHourlyBillingRate';
    HolidayHourlyBillingRate : string = this.i + 'HolidayHourlyBillingRate';
    TravelHourlyBillingRate : string = this.i + 'TravelHourlyBillingRate';
    MileageBillingRate : string = this.i + 'MileageBillingRate';
    MaxTravelInHours : string = this.i + 'MaxTravelInHours';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    ModifiedByUserId : string = this.i + 'ModifiedByUserId';
    TripCharge : string = this.i + 'TripCharge';
    ExpediteFee : string = this.i + 'ExpediteFee';
    IsEscalationEnabled : string = this.i + 'IsEscalationEnabled';
    SendPriorityNotification : string = this.i + 'SendPriorityNotification';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberPriority|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumberPriority|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Modified By User */
            EthosUserByModifiedByUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumberPriority|ModifiedByUserId',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_JobNumberPriority|Ethos_Job|JobNumberPriorityId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
    };
}

export class EthosJobSiteMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobSite.';

    constructor() {
        this.ItemDetail.ItemId=2636;
        this.ItemDetail.ItemName='Ethos_JobSite';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobSiteId : string = this.i + 'JobSiteId';
    JobId : string = this.i + 'JobId';
    SiteId : string = this.i + 'SiteId';
    IsDeleted : string = this.i + 'IsDeleted';
    LookUpKey : string = this.i + 'LookUpKey';
    SubJobNumber : string = this.i + 'SubJobNumber';
    FullJobNumber : string = this.i + 'FullJobNumber';

    Relations = {
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_Job|Ethos_JobSite|JobId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
            /** Relation: Ethos Job */
            EthosJobByJobId : {
                RelationName: 'Job Site -> Job',
                FieldPrefix: 'EthosJobJobId',
                PropertyName: 'EthosJobJobId'
            },
            /** Relation: Ethos Job Sow */
            EthosJobSow : {
                RelationName: 'Ethos_JobSite|Ethos_JobSow|JobSiteId',
                FieldPrefix: 'EthosJobSow',
                PropertyName: 'EthosJobSow'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'Ethos_JobSite|permits2_Permit|JobSiteId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
    };
}

export class EthosJobSowMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobSow.';

    constructor() {
        this.ItemDetail.ItemId=2637;
        this.ItemDetail.ItemName='Ethos_JobSow';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobSowId : string = this.i + 'JobSowId';
    SowId : string = this.i + 'SowId';
    JobId : string = this.i + 'JobId';
    JobSiteId : string = this.i + 'JobSiteId';
    LookUpKey : string = this.i + 'LookUpKey';

    Relations = {
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_Job|Ethos_JobSow|JobId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_JobSite|Ethos_JobSow|JobSiteId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
    };
}

export class EthosOpportunityMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_Opportunity.';

    constructor() {
        this.ItemDetail.ItemId=2693;
        this.ItemDetail.ItemName='Ethos_Opportunity';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OpportunityId : string = this.i + 'OpportunityId';
    OpportunityStatusWs : string = this.i + 'OpportunityStatusWs';
    OpportunityName : string = this.i + 'OpportunityName';
    CustomerId : string = this.i + 'CustomerId';
    ProjectManagerUserId : string = this.i + 'ProjectManagerUserId';
    OpportunityManagerUserId : string = this.i + 'OpportunityManagerUserId';
    ProjectStatusWs : string = this.i + 'ProjectStatusWs';
    StartDate : string = this.i + 'StartDate';
    StopDate : string = this.i + 'StopDate';

    Relations = {
            /** Relation: Ethos User - Opportunity Manager User */
            EthosUserByOpportunityManagerUserId : {
                RelationName: 'Ethos_User|Ethos_Opportunity|OpportunityManagerUserId',
                FieldPrefix: 'OpportunityManagerEthosUser',
                PropertyName: 'OpportunityManagerEthosUser'
            },
            /** Relation: Ethos User - Project Manager User */
            EthosUserByProjectManagerUserId : {
                RelationName: 'Ethos_User|Ethos_Opportunity|ProjectManagerUserId',
                FieldPrefix: 'ProjectManagerEthosUser',
                PropertyName: 'ProjectManagerEthosUser'
            },
            /** Relation: Ethos Workflow Status - Opportunity Status */
            EthosWorkflowStatusByOpportunityStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_Opportunity|OpportunityStatusWs',
                FieldPrefix: 'OpportunityStatusWsEthosWorkflowStatus',
                PropertyName: 'OpportunityStatusWsEthosWorkflowStatus'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Opportunity-JobNumber',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ro Permits - Permit - Many */
            Permits2RoPermitsByPermitId : {
                RelationName: 'roPermits|Ethos_Opportunity|OpportunityId',
                FieldPrefix: 'PermitIdPermits2roPermits',
                PropertyName: 'PermitIdPermits2roPermits'
            },
    };
}

export class EthosUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_User.';

    constructor() {
        this.ItemDetail.ItemId=2413;
        this.ItemDetail.ItemName='Ethos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    CustomerId : string = this.i + 'CustomerId';
    SubcontractorId : string = this.i + 'SubcontractorId';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    IsVaxxed : string = this.i + 'isVaxxed';

    Relations = {
            /** Relation: Ethos Code Value - User Type */
            EthosCodeValueByUserTypeCv : {
                RelationName: 'Ethos_User|Ethos_CodeValue|UserTypeCv',
                FieldPrefix: 'UserTypeCvEthosCodeValue',
                PropertyName: 'UserTypeCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Resource Group Cv */
            EthosCodeValueByResourceGroupCv : {
                RelationName: 'Ethos_CodeValue|Ethos_User|ResourceGroupCv',
                FieldPrefix: 'ResourceGroupCvEthosCodeValue',
                PropertyName: 'ResourceGroupCvEthosCodeValue'
            },
            /** Relation: Job Number - User Id */
            EthosJobNumberByUserId : {
                RelationName: 'JobNumber->ProjectManager',
                FieldPrefix: 'UserIdEthosJobNumber',
                PropertyName: 'UserIdEthosJobNumber'
            },
            /** Relation: Ethos User - Supervisor User - One */
            EthosUserBySupervisorUserId : {
                RelationName: 'Supervisor_User',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterTeam|Ethos_User|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Ethos Workflow Status - User Status */
            EthosWorkflowStatusByUserStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_User|UserStatusWs',
                FieldPrefix: 'UserStatusWsEthosWorkflowStatus',
                PropertyName: 'UserStatusWsEthosWorkflowStatus'
            },
            /** Relation: Access Control - Created By - Many */
            Permits2AccessControlByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_AccessControl|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosPermits2AccessControl',
                PropertyName: 'CreatedByEthosPermits2AccessControl'
            },
            /** Relation: Access Control - Modified By - Many */
            Permits2AccessControlByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_AccessControl|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosPermits2AccessControl',
                PropertyName: 'ModifiedByEthosPermits2AccessControl'
            },
            /** Relation: Change Request - Created By - Many */
            ChangeRequestByCreatedByUserId : {
                RelationName: 'Ethos_User|ChangeRequest|CreatedByUserId',
                FieldPrefix: 'CreatedByChangeRequest',
                PropertyName: 'CreatedByChangeRequest'
            },
            /** Relation: Change Request - Completed By - Many */
            ChangeRequestByCompletedByUserId : {
                RelationName: 'Ethos_User|ChangeRequest|CompletedByUserId',
                FieldPrefix: 'CompletedByChangeRequest',
                PropertyName: 'CompletedByChangeRequest'
            },
            /** Relation: Ethos Job - Completed By - Many */
            EthosJobByCompletedByUserId : {
                RelationName: 'Ethos_User|Ethos_Job|CompletedByUserId',
                FieldPrefix: 'CompletedByEthosJob',
                PropertyName: 'CompletedByEthosJob'
            },
            /** Relation: Job Number - Project Mgr1 - Many */
            EthosJobNumberByProjectMgr1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|ProjectMgr1UserId',
                FieldPrefix: 'ProjectMgr1EthosJobNumber',
                PropertyName: 'ProjectMgr1EthosJobNumber'
            },
            /** Relation: Job Number - Project Mgr2 - Many */
            EthosJobNumberByProjectMgr2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|ProjectMgr2UserId',
                FieldPrefix: 'ProjectMgr2EthosJobNumber',
                PropertyName: 'ProjectMgr2EthosJobNumber'
            },
            /** Relation: Job Number - Asst Project Mgr - Many */
            EthosJobNumberByAsstProjectMgrUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|AsstProjectMgrUserId',
                FieldPrefix: 'AsstProjectMgrEthosJobNumber',
                PropertyName: 'AsstProjectMgrEthosJobNumber'
            },
            /** Relation: Job Number - Senior Mgr - Many */
            EthosJobNumberBySeniorMgrUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|SeniorMgrUserId',
                FieldPrefix: 'SeniorMgrEthosJobNumber',
                PropertyName: 'SeniorMgrEthosJobNumber'
            },
            /** Relation: Job Number - Lead Tech1 - Many */
            EthosJobNumberByLeadTech1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|LeadTech1UserId',
                FieldPrefix: 'LeadTech1EthosJobNumber',
                PropertyName: 'LeadTech1EthosJobNumber'
            },
            /** Relation: Job Number - Lead Tech2 - Many */
            EthosJobNumberByLeadTech2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|LeadTech2UserId',
                FieldPrefix: 'LeadTech2EthosJobNumber',
                PropertyName: 'LeadTech2EthosJobNumber'
            },
            /** Relation: Job Number - Invoice Approval1 - Many */
            EthosJobNumberByInvoiceApproval1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|InvoiceApproval1UserId',
                FieldPrefix: 'InvoiceApproval1EthosJobNumber',
                PropertyName: 'InvoiceApproval1EthosJobNumber'
            },
            /** Relation: Job Number - Invoice Approval2 - Many */
            EthosJobNumberByInvoiceApproval2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|InvoiceApproval2UserId',
                FieldPrefix: 'InvoiceApproval2EthosJobNumber',
                PropertyName: 'InvoiceApproval2EthosJobNumber'
            },
            /** Relation: Job Number Forecast - Created By - Many */
            EthosJobNumberForecastByCreatedBy : {
                RelationName: 'Ethos_User|Ethos_JobNumberForecast|CreatedBy',
                FieldPrefix: 'CreatedByEthosJobNumberForecast',
                PropertyName: 'CreatedByEthosJobNumberForecast'
            },
            /** Relation: Job Number Forecast - Modified By - Many */
            EthosJobNumberForecastByModifiedBy : {
                RelationName: 'Ethos_User|Ethos_JobNumberForecast|ModifiedBy',
                FieldPrefix: 'ModifiedByEthosJobNumberForecast',
                PropertyName: 'ModifiedByEthosJobNumberForecast'
            },
            /** Relation: Ethos Job Number Membership */
            EthosJobNumberMembership : {
                RelationName: 'Ethos_User|Ethos_JobNumberMembership|UserId',
                FieldPrefix: 'EthosJobNumberMembership',
                PropertyName: 'EthosJobNumberMembership'
            },
            /** Relation: Ethos Job Number Priority - Created By - Many */
            EthosJobNumberPriorityByCreatedByUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumberPriority|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosJobNumberPriority',
                PropertyName: 'CreatedByEthosJobNumberPriority'
            },
            /** Relation: Ethos Job Number Priority - Modified By - Many */
            EthosJobNumberPriorityByModifiedByUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumberPriority|ModifiedByUserId',
                FieldPrefix: 'ModifiedByEthosJobNumberPriority',
                PropertyName: 'ModifiedByEthosJobNumberPriority'
            },
            /** Relation: Ethos Opportunity - Opportunity Manager - Many */
            EthosOpportunityByOpportunityManagerUserId : {
                RelationName: 'Ethos_User|Ethos_Opportunity|OpportunityManagerUserId',
                FieldPrefix: 'OpportunityManagerEthosOpportunity',
                PropertyName: 'OpportunityManagerEthosOpportunity'
            },
            /** Relation: Ethos Opportunity - Project Manager - Many */
            EthosOpportunityByProjectManagerUserId : {
                RelationName: 'Ethos_User|Ethos_Opportunity|ProjectManagerUserId',
                FieldPrefix: 'ProjectManagerEthosOpportunity',
                PropertyName: 'ProjectManagerEthosOpportunity'
            },
            /** Relation: Ethos User Diff - Many */
            EthosUserDiffByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_UserDiff|Ethos_UserId',
                FieldPrefix: 'EthosEthosUserDiff',
                PropertyName: 'EthosEthosUserDiff'
            },
            /** Relation: User Skill */
            EthosUserSkill : {
                RelationName: 'Ethos_User|Ethos_UserSkill|UserId',
                FieldPrefix: 'EthosUserSkill',
                PropertyName: 'EthosUserSkill'
            },
            /** Relation: Wachter Department - Department Director - Many */
            EthosWachterDepartmentByDepartmentDirectorUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentDirectorUserId',
                FieldPrefix: 'DepartmentDirectorEthosWachterDepartment',
                PropertyName: 'DepartmentDirectorEthosWachterDepartment'
            },
            /** Relation: Wachter Department - Department Manager - Many */
            EthosWachterDepartmentByDepartmentManagerUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentManagerUserId',
                FieldPrefix: 'DepartmentManagerEthosWachterDepartment',
                PropertyName: 'DepartmentManagerEthosWachterDepartment'
            },
            /** Relation: Wachter Department - Department Asst Manager - Many */
            EthosWachterDepartmentByDepartmentAsstManagerUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentAsstManagerUserId',
                FieldPrefix: 'DepartmentAsstManagerEthosWachterDepartment',
                PropertyName: 'DepartmentAsstManagerEthosWachterDepartment'
            },
            /** Relation: Wachter Team - Team Leader - Many */
            EthosWachterTeamByTeamLeaderUserId : {
                RelationName: 'Ethos_User|Ethos_WachterTeam|TeamLeaderUserId',
                FieldPrefix: 'TeamLeaderEthosWachterTeam',
                PropertyName: 'TeamLeaderEthosWachterTeam'
            },
            /** Relation: Inspection - Created By - Many */
            Permits2InspectionByCreatedByUserId : {
                RelationName: 'Ethos_User|permits2_Inspection|CreatedByUserId',
                FieldPrefix: 'CreatedByPermits2Inspection',
                PropertyName: 'CreatedByPermits2Inspection'
            },
            /** Relation: Inspection - Technician - Many */
            Permits2InspectionByTechnicianUserId : {
                RelationName: 'Ethos_User|permits2_Inspection|TechnicianUserId',
                FieldPrefix: 'TechnicianPermits2Inspection',
                PropertyName: 'TechnicianPermits2Inspection'
            },
            /** Relation: Permit - Created By - Many */
            Permits2PermitByCreatedByUserId : {
                RelationName: 'Ethos_User|permits2_Permit|CreatedByUserId',
                FieldPrefix: 'CreatedByPermits2Permit',
                PropertyName: 'CreatedByPermits2Permit'
            },
            /** Relation: Permit - Modified By - Many */
            Permits2PermitByModifiedByUserId : {
                RelationName: 'Ethos_User|permits2_Permit|ModifiedByUserId',
                FieldPrefix: 'ModifiedByPermits2Permit',
                PropertyName: 'ModifiedByPermits2Permit'
            },
            /** Relation: Permit - Requested By - Many */
            Permits2PermitByRequestedByUserId : {
                RelationName: 'Ethos_User|permits2_Permit|RequestedByUserId',
                FieldPrefix: 'RequestedByPermits2Permit',
                PropertyName: 'RequestedByPermits2Permit'
            },
            /** Relation: Permit - Assigned To - Many */
            Permits2PermitByAssignedToUserId : {
                RelationName: 'Ethos_User|permits2_Permit|AssignedToUserId',
                FieldPrefix: 'AssignedToPermits2Permit',
                PropertyName: 'AssignedToPermits2Permit'
            },
            /** Relation: Required Cable - Created By - Many */
            Permits2RequiredCableByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_RequiredCable|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosPermits2RequiredCable',
                PropertyName: 'CreatedByEthosPermits2RequiredCable'
            },
            /** Relation: Required Cable - Modified By - Many */
            Permits2RequiredCableByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_RequiredCable|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosPermits2RequiredCable',
                PropertyName: 'ModifiedByEthosPermits2RequiredCable'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
            /** Relation: Ro Ethos User - Supervisor - Many */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'Ethos_User|roEthos_User|SupervisorUserId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
            /** Relation: Ro Permits - Project Manager - Many */
            Permits2RoPermitsByProjectManagerUserId : {
                RelationName: 'roPermits|Ethos_User|ProjectManagerUserId',
                FieldPrefix: 'ProjectManagerPermits2roPermits',
                PropertyName: 'ProjectManagerPermits2roPermits'
            },
            /** Relation: Ro Permits - Project Manager2 - Many */
            Permits2RoPermitsByProjectManager2UserId : {
                RelationName: 'roPermits|Ethos_User|ProjectManager2UserId',
                FieldPrefix: 'ProjectManager2Permits2roPermits',
                PropertyName: 'ProjectManager2Permits2roPermits'
            },
            /** Relation: Stage Audit Log - Status Updated By - Many */
            StageAuditLogByStatusUpdatedByUserId : {
                RelationName: 'Ethos_User|StageAuditLog|StatusUpdatedByUserId',
                FieldPrefix: 'StatusUpdatedByStageAuditLog',
                PropertyName: 'StatusUpdatedByStageAuditLog'
            },
    };
}

export class EthosUserDiffMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserDiff.';

    constructor() {
        this.ItemDetail.ItemId=2572;
        this.ItemDetail.ItemName='Ethos_UserDiff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserDiffId : string = this.i + 'Ethos_UserDiffId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FieldName : string = this.i + 'FieldName';
    OldValue : string = this.i + 'OldValue';
    NewValue : string = this.i + 'NewValue';
    ChangedDateTime : string = this.i + 'ChangedDateTime';

    Relations = {
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_UserDiff|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class EthosUserSkillMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserSkill.';

    constructor() {
        this.ItemDetail.ItemId=2410;
        this.ItemDetail.ItemName='Ethos_UserSkill';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserSkillId : string = this.i + 'UserSkillId';
    UserId : string = this.i + 'UserId';
    SkillCv : string = this.i + 'SkillCv';
    Meaning : string = this.i + 'Meaning';
    Display : string = this.i + 'Display';

    Relations = {
            /** Relation: Ethos Code Value - Skill */
            EthosCodeValueBySkillCv : {
                RelationName: 'Ethos_CodeValue|Ethos_UserSkill|SkillCv',
                FieldPrefix: 'SkillCvEthosCodeValue',
                PropertyName: 'SkillCvEthosCodeValue'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_UserSkill|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
    };
}

export class EthosWachterDepartmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterDepartment.';

    constructor() {
        this.ItemDetail.ItemId=2388;
        this.ItemDetail.ItemName='Ethos_WachterDepartment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    DepartmentTypeCv : string = this.i + 'DepartmentTypeCv';
    DepartmentTypeMeaning : string = this.i + 'DepartmentTypeMeaning';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    DepartmentDirectorUserId : string = this.i + 'DepartmentDirectorUserId';
    IsDeleted : string = this.i + 'IsDeleted';
    DepartmentManagerUserId : string = this.i + 'DepartmentManagerUserId';
    DepartmentAsstManagerUserId : string = this.i + 'DepartmentAsstManagerUserId';
    JobNumberId : string = this.i + 'JobNumberId';
    AxIntegrationId : string = this.i + 'AxIntegrationId';
    JobNumberPhaseId : string = this.i + 'JobNumberPhaseId';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';

    Relations = {
            /** Relation: Ethos Code Value - Department Type */
            EthosCodeValueByDepartmentTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_WachterDepartment|DepartmentTypeCv',
                FieldPrefix: 'DepartmentTypeCvEthosCodeValue',
                PropertyName: 'DepartmentTypeCvEthosCodeValue'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_WachterDepartment|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos Job Number Phase */
            EthosJobNumberPhase : {
                RelationName: 'Ethos_JobNumberPhase|Ethos_WachterDepartment|JobNumberPhaseId',
                FieldPrefix: 'EthosJobNumberPhase',
                PropertyName: 'EthosJobNumberPhase'
            },
            /** Relation: Ethos User - Department Director User */
            EthosUserByDepartmentDirectorUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentDirectorUserId',
                FieldPrefix: 'DepartmentDirectorEthosUser',
                PropertyName: 'DepartmentDirectorEthosUser'
            },
            /** Relation: Ethos User - Department Manager User */
            EthosUserByDepartmentManagerUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentManagerUserId',
                FieldPrefix: 'DepartmentManagerEthosUser',
                PropertyName: 'DepartmentManagerEthosUser'
            },
            /** Relation: Ethos User - Department Asst Manager User */
            EthosUserByDepartmentAsstManagerUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentAsstManagerUserId',
                FieldPrefix: 'DepartmentAsstManagerEthosUser',
                PropertyName: 'DepartmentAsstManagerEthosUser'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterDepartment|Ethos_WachterTeam|WachterDepartmentId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_WachterDepartment|roEthos_User|WachterDepartmentId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
    };
}

export class EthosWachterTeamMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterTeam.';

    constructor() {
        this.ItemDetail.ItemId=2412;
        this.ItemDetail.ItemName='Ethos_WachterTeam';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    TeamTypeCv : string = this.i + 'TeamTypeCv';
    TeamTypeMeaning : string = this.i + 'TeamTypeMeaning';
    TeamName : string = this.i + 'TeamName';
    TeamLeaderUserId : string = this.i + 'TeamLeaderUserId';
    AxIntegrationId : string = this.i + 'AxIntegrationId';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    IsDeleted : string = this.i + 'IsDeleted';
    OverheadJobNumberId : string = this.i + 'OverheadJobNumberId';
    OverheadJobNumberPhaseId : string = this.i + 'OverheadJobNumberPhaseId';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';

    Relations = {
            /** Relation: Ethos Code Value - Team Type */
            EthosCodeValueByTeamTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_WachterTeam|TeamTypeCv',
                FieldPrefix: 'TeamTypeCvEthosCodeValue',
                PropertyName: 'TeamTypeCvEthosCodeValue'
            },
            /** Relation: Job Number - Overhead Job Number */
            EthosJobNumberByOverheadJobNumberId : {
                RelationName: 'Ethos_JobNumber|Ethos_WachterTeam|OverheadJobNumberId',
                FieldPrefix: 'OverheadEthosJobNumber',
                PropertyName: 'OverheadEthosJobNumber'
            },
            /** Relation: Ethos Job Number Phase - Overhead Job Number Phase */
            EthosJobNumberPhaseByOverheadJobNumberPhaseId : {
                RelationName: 'Ethos_JobNumberPhase|Ethos_WachterTeam|OverheadJobNumberPhaseId',
                FieldPrefix: 'OverheadEthosJobNumberPhase',
                PropertyName: 'OverheadEthosJobNumberPhase'
            },
            /** Relation: Ethos User - Team Leader User */
            EthosUserByTeamLeaderUserId : {
                RelationName: 'Ethos_User|Ethos_WachterTeam|TeamLeaderUserId',
                FieldPrefix: 'TeamLeaderEthosUser',
                PropertyName: 'TeamLeaderEthosUser'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_WachterDepartment|Ethos_WachterTeam|WachterDepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'JobNumber|WachterTeam|WachterTeamId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_WachterTeam|Ethos_User|WachterTeamId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_WachterTeam|roEthos_User|WachterTeamId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
    };
}

export class EthosWorkflowStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WorkflowStatus.';

    constructor() {
        this.ItemDetail.ItemId=2581;
        this.ItemDetail.ItemName='Ethos_WorkflowStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WorkflowStatusId : string = this.i + 'WorkflowStatusId';
    WorkflowStatusSetId : string = this.i + 'WorkflowStatusSetId';
    WorkflowStatus : string = this.i + 'WorkflowStatus';
    WorkflowStatusMeaning : string = this.i + 'WorkflowStatusMeaning';
    WorkflowStatusOrder : string = this.i + 'WorkflowStatusOrder';
    IsActive : string = this.i + 'IsActive';
    WorkflowStatusShortName : string = this.i + 'WorkflowStatusShortName';

    Relations = {
            /** Relation: Ethos Workflow Status Set */
            EthosWorkflowStatusSet : {
                RelationName: 'Ethos_WorkflowStatusSet|Ethos_WorkflowStatus|WorkflowStatusSetId',
                FieldPrefix: 'EthosWorkflowStatusSet',
                PropertyName: 'EthosWorkflowStatusSet'
            },
            /** Relation: Ethos Job - Job Status Ws - Many */
            EthosJobByJobStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_Job|JobStatusWs',
                FieldPrefix: 'JobStatusWsEthosJob',
                PropertyName: 'JobStatusWsEthosJob'
            },
            /** Relation: Job Number - Job Number Status Ws - Many */
            EthosJobNumberByJobNumberStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_JobNumber|JobNumberStatusWs',
                FieldPrefix: 'JobNumberStatusWsEthosJobNumber',
                PropertyName: 'JobNumberStatusWsEthosJobNumber'
            },
            /** Relation: Ethos Job Number Phase - Job Number Phase Status Ws - Many */
            EthosJobNumberPhaseByJobNumberPhaseStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_JobNumberPhase|JobNumberPhaseStatusWs',
                FieldPrefix: 'JobNumberPhaseStatusWsEthosJobNumberPhase',
                PropertyName: 'JobNumberPhaseStatusWsEthosJobNumberPhase'
            },
            /** Relation: Ethos Opportunity - Opportunity Status Ws - Many */
            EthosOpportunityByOpportunityStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_Opportunity|OpportunityStatusWs',
                FieldPrefix: 'OpportunityStatusWsEthosOpportunity',
                PropertyName: 'OpportunityStatusWsEthosOpportunity'
            },
            /** Relation: Ethos User - User Status Ws - Many */
            EthosUserByUserStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_User|UserStatusWs',
                FieldPrefix: 'UserStatusWsEthosUser',
                PropertyName: 'UserStatusWsEthosUser'
            },
            /** Relation: Ro Ethos User - User Status Ws - Many */
            RoEthosUserByUserStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|roEthos_User|UserStatusWs',
                FieldPrefix: 'UserStatusWsRoEthosUser',
                PropertyName: 'UserStatusWsRoEthosUser'
            },
    };
}

export class EthosWorkflowStatusSetMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WorkflowStatusSet.';

    constructor() {
        this.ItemDetail.ItemId=2580;
        this.ItemDetail.ItemName='Ethos_WorkflowStatusSet';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WorkflowStatusSetId : string = this.i + 'WorkflowStatusSetId';
    WorkflowStatusSetName : string = this.i + 'WorkflowStatusSetName';
    MetaDataItemId : string = this.i + 'MetaDataItemId';
    MetaDataAttributeId : string = this.i + 'MetaDataAttributeId';
    RelatedCodeSetId : string = this.i + 'RelatedCodeSetId';
    UseTransitions : string = this.i + 'UseTransitions';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Ethos Workflow Status */
            EthosWorkflowStatus : {
                RelationName: 'Ethos_WorkflowStatusSet|Ethos_WorkflowStatus|WorkflowStatusSetId',
                FieldPrefix: 'EthosWorkflowStatus',
                PropertyName: 'EthosWorkflowStatus'
            },
    };
}

export class Permits2InspectionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_Inspection.';

    constructor() {
        this.ItemDetail.ItemId=2782;
        this.ItemDetail.ItemName='permits2_Inspection';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    InspectionId : string = this.i + 'InspectionId';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    InspectionType : string = this.i + 'InspectionType';
    TechnicianUserId : string = this.i + 'TechnicianUserId';
    AvailableDates : string = this.i + 'AvailableDates';
    PreferredTimeOfDayCv : string = this.i + 'PreferredTimeOfDayCv';
    AdditionalNotes : string = this.i + 'AdditionalNotes';
    InspectionNotes : string = this.i + 'InspectionNotes';
    ScheduledDateTime : string = this.i + 'ScheduledDateTime';
    ScheduledNotes : string = this.i + 'ScheduledNotes';
    ResultCv : string = this.i + 'ResultCv';
    ResultDateTime : string = this.i + 'ResultDateTime';
    ResultNotes : string = this.i + 'ResultNotes';
    InspectionStatusId : string = this.i + 'InspectionStatusId';
    SyncStatus : string = this.i + 'SyncStatus';
    Subcontractor : string = this.i + 'Subcontractor';
    UseSub : string = this.i + 'UseSub';

    Relations = {
            /** Relation: Trust Code Value - Preferred Time Of Day */
            CodeValueByPreferredTimeOfDayCv : {
                RelationName: 'CodeValue|permits2_Inspection|PreferredTimeOfDayCv',
                FieldPrefix: 'PreferredTimeOfDayCvCodeValue',
                PropertyName: 'PreferredTimeOfDayCvCodeValue'
            },
            /** Relation: Inspection Result - Result */
            InspectionResultByResultCv : {
                RelationName: 'InspectionResult|permits2_Inspection|ResultCv',
                FieldPrefix: 'ResultCvInspectionResult',
                PropertyName: 'ResultCvInspectionResult'
            },
            /** Relation: Inspection Status */
            InspectionStatus : {
                RelationName: 'InspectionStatus|permits2_Inspection|InspectionStatusId',
                FieldPrefix: 'InspectionStatus',
                PropertyName: 'InspectionStatus'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'permits2_Permit|permits2_Inspection|PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|permits2_Inspection|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Technician */
            EthosUserByTechnicianUserId : {
                RelationName: 'Ethos_User|permits2_Inspection|TechnicianUserId',
                FieldPrefix: 'TechnicianEthosUser',
                PropertyName: 'TechnicianEthosUser'
            },
    };
}

export class InspectionResultMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'InspectionResult.';

    constructor() {
        this.ItemDetail.ItemId=2784;
        this.ItemDetail.ItemName='InspectionResult';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    InspectionResultId : string = this.i + 'InspectionResultId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    Order : string = this.i + 'Order';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Inspection - Result Cv - Many */
            Permits2InspectionByResultCv : {
                RelationName: 'InspectionResult|permits2_Inspection|ResultCv',
                FieldPrefix: 'ResultCvPermits2Inspection',
                PropertyName: 'ResultCvPermits2Inspection'
            },
    };
}

export class InspectionStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'InspectionStatus.';

    constructor() {
        this.ItemDetail.ItemId=2785;
        this.ItemDetail.ItemName='InspectionStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    InspectionStatusId : string = this.i + 'InspectionStatusId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    Order : string = this.i + 'Order';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Inspection */
            Permits2Inspection : {
                RelationName: 'InspectionStatus|permits2_Inspection|InspectionStatusId',
                FieldPrefix: 'Permits2Inspection',
                PropertyName: 'Permits2Inspection'
            },
    };
}

export class NoteTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'NoteType.';

    constructor() {
        this.ItemDetail.ItemId=2732;
        this.ItemDetail.ItemName='NoteType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    NoteTypeId : string = this.i + 'NoteTypeId';
    NoteType : string = this.i + 'NoteType';
    MetaDataLookupId : string = this.i + 'MetaDataLookupId';

    Relations = {
    };
}

export class Permits2PermitMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_Permit.';

    constructor() {
        this.ItemDetail.ItemId=2777;
        this.ItemDetail.ItemName='permits2_Permit';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitId : string = this.i + 'PermitId';
    LegacyPermitRequestId : string = this.i + 'LegacyPermitRequestId';
    LegacyPermitId : string = this.i + 'LegacyPermitId';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    ModifiedByUserId : string = this.i + 'ModifiedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    PermitRequestTypeCv : string = this.i + 'PermitRequestTypeCv';
    PermitTeamCv : string = this.i + 'PermitTeamCv';
    RushRequested : string = this.i + 'RushRequested';
    DueDate : string = this.i + 'DueDate';
    RequestedByUserId : string = this.i + 'RequestedByUserId';
    EmailCopyString : string = this.i + 'EmailCopyString';
    AssignedToUserId : string = this.i + 'AssignedToUserId';
    FollowUpDate : string = this.i + 'FollowUpDate';
    IsLicenceRequired : string = this.i + 'IsLicenceRequired';
    HasLicenseFile : string = this.i + 'HasLicenseFile';
    FollowUpDescription : string = this.i + 'FollowUpDescription';
    EstimatedStartDate : string = this.i + 'EstimatedStartDate';
    EstimatedCompletionDate : string = this.i + 'EstimatedCompletionDate';
    JobId : string = this.i + 'JobId';
    JobSiteId : string = this.i + 'JobSiteId';
    Jurisdiction : string = this.i + 'Jurisdiction';
    NoteParentId : string = this.i + 'NoteParentId';
    PerformingWorkCv : string = this.i + 'PerformingWorkCv';
    SubContractorLicenseNumber : string = this.i + 'SubContractorLicenseNumber';
    CardReader : string = this.i + 'CardReader';
    CardReaderQuantity : string = this.i + 'CardReaderQuantity';
    Paging : string = this.i + 'Paging';
    IsTyingIntoFireAlarm : string = this.i + 'IsTyingIntoFireAlarm';
    VoiceDataPlenumRated : string = this.i + 'VoiceDataPlenumRated';
    DataVoiceUsingExisting : string = this.i + 'DataVoiceUsingExisting';
    DataVoiceReplacingCable : string = this.i + 'DataVoiceReplacingCable';
    DataVoiceNewCable : string = this.i + 'DataVoiceNewCable';
    CCTVPlenumRated : string = this.i + 'CCTVPlenumRated';
    HasCameras : string = this.i + 'HasCameras';
    CamerasQuantity : string = this.i + 'CamerasQuantity';
    CCTVUsingExisting : string = this.i + 'CCTVUsingExisting';
    CCTVReplacingCable : string = this.i + 'CCTVReplacingCable';
    CCTVNewCable : string = this.i + 'CCTVNewCable';
    CCTVInstallTypeCv : string = this.i + 'CCTVInstallTypeCv';
    CCTVOtherInstallType : string = this.i + 'CCTVOtherInstallType';
    AudioPlenumRated : string = this.i + 'AudioPlenumRated';
    HasSpeakers : string = this.i + 'HasSpeakers';
    SpeakersQuantity : string = this.i + 'SpeakersQuantity';
    IsSwappingOutPanel : string = this.i + 'IsSwappingOutPanel';
    IsNewFireSystem : string = this.i + 'IsNewFireSystem';
    FireAlarmInitiatingDevices : string = this.i + 'FireAlarmInitiatingDevices';
    FireAlarmDemoInstallCv : string = this.i + 'FireAlarmDemoInstallCv';
    FireAlarmInstallRadio : string = this.i + 'FireAlarmInstallRadio';
    OutletQuantity : string = this.i + 'OutletQuantity';
    TotalAmps : string = this.i + 'TotalAmps';
    PanelsQuantity : string = this.i + 'PanelsQuantity';
    CircuitsQuantity : string = this.i + 'CircuitsQuantity';
    ElectricalOutletTypeCv : string = this.i + 'ElectricalOutletTypeCv';
    ElectricalOtherOutletType : string = this.i + 'ElectricalOtherOutletType';
    ElectricalWorkTypeCv : string = this.i + 'ElectricalWorkTypeCv';
    ElectricalOtherWorkType : string = this.i + 'ElectricalOtherWorkType';
    ElectricalDifferentTypeCv : string = this.i + 'ElectricalDifferentTypeCv';
    ElectricalOtherDifferentType : string = this.i + 'ElectricalOtherDifferentType';
    IsLicensedTechnician : string = this.i + 'IsLicensedTechnician';
    TechnicianNameAndLicenseNumber : string = this.i + 'TechnicianNameAndLicenseNumber';
    ElectricalTotalVoltage : string = this.i + 'ElectricalTotalVoltage';
    HasPanelInstallation : string = this.i + 'HasPanelInstallation';
    BurglarAlarmPanelQuantity : string = this.i + 'BurglarAlarmPanelQuantity';
    BurglarAlarmDeviceType : string = this.i + 'BurglarAlarmDeviceType';
    NumberOfRooms : string = this.i + 'NumberOfRooms';
    FloorCount : string = this.i + 'FloorCount';
    PlenumRiserCv : string = this.i + 'PlenumRiserCv';
    HasUndergroundCabling : string = this.i + 'HasUndergroundCabling';
    HasCableInConduit : string = this.i + 'HasCableInConduit';
    GCPresent : string = this.i + 'GCPresent';
    GCName : string = this.i + 'GCName';
    GCPermitNumber : string = this.i + 'GCPermitNumber';
    ValuationOverallContract : string = this.i + 'ValuationOverallContract';
    ValuationOverallSOW : string = this.i + 'ValuationOverallSOW';
    NewConstruction : string = this.i + 'NewConstruction';
    ExistingBuilding : string = this.i + 'ExistingBuilding';
    CountOfNac : string = this.i + 'CountOfNac';
    FacilityFootage : string = this.i + 'FacilityFootage';
    WorkplaceFootage : string = this.i + 'WorkplaceFootage';
    ScopeOfWork : string = this.i + 'ScopeOfWork';
    MergeDeleted : string = this.i + 'MergeDeleted';
    PropertyOwnerName : string = this.i + 'PropertyOwnerName';
    PropertyOwnerCity : string = this.i + 'PropertyOwnerCity';
    PropertyOwnerStateId : string = this.i + 'PropertyOwnerStateId';
    PropertyOwnerPostalCode : string = this.i + 'PropertyOwnerPostalCode';
    PropertyOwnerAddress : string = this.i + 'PropertyOwnerAddress';
    PermitCost : string = this.i + 'PermitCost';
    CanBePulledOnline : string = this.i + 'CanBePulledOnline';
    WachterPermitNumber : string = this.i + 'WachterPermitNumber';
    ExpirationDate : string = this.i + 'ExpirationDate';
    InfoNeededNote : string = this.i + 'InfoNeededNote';
    FilesInSharepoint : string = this.i + 'FilesInSharepoint';
    SharepointId : string = this.i + 'SharepointId';
    PermitStatusId : string = this.i + 'PermitStatusId';
    MediaGroupId : string = this.i + 'MediaGroupId';
    SubPanelQuantity : string = this.i + 'SubPanelQuantity';
    FixtureQuantity : string = this.i + 'FixtureQuantity';
    AdditionalNotesElectrical : string = this.i + 'AdditionalNotesElectrical';
    CountAdditionalDevicesFire : string = this.i + 'CountAdditionalDevicesFire';
    AdditionalDeviceDescriptionFire : string = this.i + 'AdditionalDeviceDescriptionFire';
    CountAdditionalDevicesBurglar : string = this.i + 'CountAdditionalDevicesBurglar';
    AdditionalDeviceDescriptionBurglar : string = this.i + 'AdditionalDeviceDescriptionBurglar';
    CompleteDate : string = this.i + 'CompleteDate';
    TechnicianOnSite : string = this.i + 'TechnicianOnSite';
    PermitRequired : string = this.i + 'PermitRequired';
    HasExceptions : string = this.i + 'HasExceptions';
    InspectionRequired : string = this.i + 'InspectionRequired';
    ApplyForPermit : string = this.i + 'ApplyForPermit';
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumberAddress1 : string = this.i + 'JobNumberAddress1';
    JobNumberAddress2 : string = this.i + 'JobNumberAddress2';
    JobNumberCity : string = this.i + 'JobNumberCity';
    JobNumberStateProvinceId : string = this.i + 'JobNumberStateProvinceId';
    JobNumberPostalCode : string = this.i + 'JobNumberPostalCode';
    ChangeRequestId : string = this.i + 'ChangeRequestId';

    Relations = {
            /** Relation: Change Request */
            ChangeRequest : {
                RelationName: 'ChangeRequest|permits2_Permit|ChangeRequestId',
                FieldPrefix: 'ChangeRequest',
                PropertyName: 'ChangeRequest'
            },
            /** Relation: Trust Code Value - Permit Request Type */
            CodeValueByPermitRequestTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|PermitRequestTypeCv',
                FieldPrefix: 'PermitRequestTypeCvCodeValue',
                PropertyName: 'PermitRequestTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Type of Install */
            CodeValueByCCTVInstallTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|CCTVInstallTypeCv',
                FieldPrefix: 'CCTVInstallTypeCvCodeValue',
                PropertyName: 'CCTVInstallTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Different Types of Electrical */
            CodeValueByElectricalDifferentTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|ElectricalDifferentTypeCv',
                FieldPrefix: 'ElectricalDifferentTypeCvCodeValue',
                PropertyName: 'ElectricalDifferentTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Outlet Type */
            CodeValueByElectricalOutletTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|ElectricalOutletTypeCv',
                FieldPrefix: 'ElectricalOutletTypeCvCodeValue',
                PropertyName: 'ElectricalOutletTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Work Type */
            CodeValueByElectricalWorkTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|ElectricalWorkTypeCv',
                FieldPrefix: 'ElectricalWorkTypeCvCodeValue',
                PropertyName: 'ElectricalWorkTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Demo or Install */
            CodeValueByFireAlarmDemoInstallCv : {
                RelationName: 'CodeValue|permits2_Permit|FireAlarmDemoInstallCv',
                FieldPrefix: 'FireAlarmDemoInstallCvCodeValue',
                PropertyName: 'FireAlarmDemoInstallCvCodeValue'
            },
            /** Relation: Ethos Code Value - Permit Team */
            EthosCodeValueByPermitTeamCv : {
                RelationName: 'Ethos_CodeValue|permits2_Permit|PermitTeamCv',
                FieldPrefix: 'PermitTeamCvEthosCodeValue',
                PropertyName: 'PermitTeamCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Plenum Or Riser */
            EthosCodeValueByPlenumRiserCv : {
                RelationName: 'Ethos_CodeValue|permits2_Permit|PlenumRiserCv',
                FieldPrefix: 'PlenumRiserCvEthosCodeValue',
                PropertyName: 'PlenumRiserCvEthosCodeValue'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_Job|permits2_Permit|JobId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|permits2_Permit|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_JobSite|permits2_Permit|JobSiteId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
            /** Relation: Ro Permits */
            Permits2RoPermits : {
                RelationName: 'roPermits|permits2.Permit|PermitId',
                FieldPrefix: 'Permits2roPermits',
                PropertyName: 'Permits2roPermits'
            },
            /** Relation: Permit Status */
            Permits2PermitStatus : {
                RelationName: 'permits2_PermitStatus|permits2_Permit|PermitStatusId',
                FieldPrefix: 'Permits2PermitStatus',
                PropertyName: 'Permits2PermitStatus'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|permits2_Permit|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByUserId : {
                RelationName: 'Ethos_User|permits2_Permit|ModifiedByUserId',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
            /** Relation: Ethos User - Requested By */
            EthosUserByRequestedByUserId : {
                RelationName: 'Ethos_User|permits2_Permit|RequestedByUserId',
                FieldPrefix: 'RequestedByEthosUser',
                PropertyName: 'RequestedByEthosUser'
            },
            /** Relation: Ethos User - Assigned To */
            EthosUserByAssignedToUserId : {
                RelationName: 'Ethos_User|permits2_Permit|AssignedToUserId',
                FieldPrefix: 'AssignedToEthosUser',
                PropertyName: 'AssignedToEthosUser'
            },
            /** Relation: Access Control */
            Permits2AccessControl : {
                RelationName: 'permits2_Permit|permits2_AccessControl|PermitId',
                FieldPrefix: 'Permits2AccessControl',
                PropertyName: 'Permits2AccessControl'
            },
            /** Relation: Inspection */
            Permits2Inspection : {
                RelationName: 'permits2_Permit|permits2_Inspection|PermitId',
                FieldPrefix: 'Permits2Inspection',
                PropertyName: 'Permits2Inspection'
            },
            /** Relation: Permit Permit Type */
            Permits2PermitPermitType : {
                RelationName: 'permits2_Permit|permits2_PermitPermitType|PermitId',
                FieldPrefix: 'Permits2PermitPermitType',
                PropertyName: 'Permits2PermitPermitType'
            },
            /** Relation: Required Cable */
            Permits2RequiredCable : {
                RelationName: 'permits2_Permit|permits2_RequiredCable|PermitId',
                FieldPrefix: 'Permits2RequiredCable',
                PropertyName: 'Permits2RequiredCable'
            },
            /** Relation: Ro Inspections */
            Permits2RoInspections : {
                RelationName: 'roInspections|Permitv2|PermitId',
                FieldPrefix: 'Permits2roInspections',
                PropertyName: 'Permits2roInspections'
            },
            /** Relation: Stage Audit Log */
            StageAuditLog : {
                RelationName: 'permits2_Permit|StageAuditLog|PermitId',
                FieldPrefix: 'StageAuditLog',
                PropertyName: 'StageAuditLog'
            },
    };
}

export class Permits2PermitPermitTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_PermitPermitType.';

    constructor() {
        this.ItemDetail.ItemId=2778;
        this.ItemDetail.ItemName='permits2_PermitPermitType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitPermitTypeId : string = this.i + 'PermitPermitTypeId';
    PermitId : string = this.i + 'PermitId';
    PermitTypeCv : string = this.i + 'PermitTypeCv';

    Relations = {
            /** Relation: Ethos Code Value - Permit Type */
            EthosCodeValueByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|permits2_PermitPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvEthosCodeValue',
                PropertyName: 'PermitTypeCvEthosCodeValue'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'permits2_Permit|permits2_PermitPermitType|PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
    };
}

export class Permits2PermitStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_PermitStatus.';

    constructor() {
        this.ItemDetail.ItemId=2783;
        this.ItemDetail.ItemName='permits2_PermitStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitStatusId : string = this.i + 'PermitStatusId';
    PermitStatusDisplay : string = this.i + 'PermitStatusDisplay';
    PermitStatusMeaning : string = this.i + 'PermitStatusMeaning';
    PermitStatusOrder : string = this.i + 'PermitStatusOrder';
    IsActive : string = this.i + 'IsActive';
    PermitStatusShortName : string = this.i + 'PermitStatusShortName';

    Relations = {
            /** Relation: Change Request - Initial - Many */
            ChangeRequestByInitialPermitStatusId : {
                RelationName: 'permits2_PermitStatus|ChangeRequest|InitialPermitStatusId',
                FieldPrefix: 'InitialChangeRequest',
                PropertyName: 'InitialChangeRequest'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'permits2_PermitStatus|permits2_Permit|PermitStatusId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Stage Audit Log */
            StageAuditLog : {
                RelationName: 'permits2_PermitStatus|StageAuditLog|PermitStatusId',
                FieldPrefix: 'StageAuditLog',
                PropertyName: 'StageAuditLog'
            },
    };
}

export class Permits2RequiredCableMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_RequiredCable.';

    constructor() {
        this.ItemDetail.ItemId=2781;
        this.ItemDetail.ItemName='permits2_RequiredCable';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RequiredCableId : string = this.i + 'RequiredCableId';
    CableTypeCv : string = this.i + 'CableTypeCv';
    Quantity : string = this.i + 'Quantity';
    Description : string = this.i + 'Description';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    PermitTypeCv : string = this.i + 'PermitTypeCv';

    Relations = {
            /** Relation: Ethos Code Value - Permit Type */
            EthosCodeValueByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|permits2_RequiredCable|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvEthosCodeValue',
                PropertyName: 'PermitTypeCvEthosCodeValue'
            },
            /** Relation: Trust Code Value - Cable Type */
            CodeValueByCableTypeCv : {
                RelationName: 'CodeValue|permits2_RequiredCable|CableTypeCv',
                FieldPrefix: 'CableTypeCvCodeValue',
                PropertyName: 'CableTypeCvCodeValue'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'permits2_Permit|permits2_RequiredCable|PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_RequiredCable|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_RequiredCable|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
    };
}

export class RoEthosUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_User.';

    constructor() {
        this.ItemDetail.ItemId=2419;
        this.ItemDetail.ItemName='roEthos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    IsActive : string = this.i + 'IsActive';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    AXId : string = this.i + 'AXId';
    YrsService : string = this.i + 'YrsService';
    StaffingAgencyName : string = this.i + 'StaffingAgencyName';

    Relations = {
            /** Relation: Ethos Code Value - Resource Group Cv */
            EthosCodeValueByResourceGroupCv : {
                RelationName: 'Ethos_CodeValue|roEthos_User|ResourceGroupCv',
                FieldPrefix: 'ResourceGroupCvEthosCodeValue',
                PropertyName: 'ResourceGroupCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - User Type */
            EthosCodeValueByUserTypeCv : {
                RelationName: 'Ethos_CodeValue|roEthos_User|UserTypeCv',
                FieldPrefix: 'UserTypeCvEthosCodeValue',
                PropertyName: 'UserTypeCvEthosCodeValue'
            },
            /** Relation: Ro Ethos User - Supervisor User - One */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'roEthos_User|roEthos_User|SupervisorId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Ethos User - Supervisor User */
            EthosUserBySupervisorUserId : {
                RelationName: 'Ethos_User|roEthos_User|SupervisorUserId',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_WachterDepartment|roEthos_User|WachterDepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterTeam|roEthos_User|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Ethos Workflow Status - User Status */
            EthosWorkflowStatusByUserStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|roEthos_User|UserStatusWs',
                FieldPrefix: 'UserStatusWsEthosWorkflowStatus',
                PropertyName: 'UserStatusWsEthosWorkflowStatus'
            },
    };
}

export class RoEthosUserOriginalMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_UserOriginal.';

    constructor() {
        this.ItemDetail.ItemId=2661;
        this.ItemDetail.ItemName='roEthos_UserOriginal';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    AXId : string = this.i + 'AXId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    EmployeeType : string = this.i + 'EmployeeType';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsActive : string = this.i + 'IsActive';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';

    Relations = {
    };
}

export class Permits2RoInspectionsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_roInspections.';

    constructor() {
        this.ItemDetail.ItemId=2786;
        this.ItemDetail.ItemName='permits2_roInspections';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    InspectionId : string = this.i + 'InspectionId';
    PreferredTimeOfDay : string = this.i + 'PreferredTimeOfDay';
    PreferredTimeOfDayCv : string = this.i + 'PreferredTimeOfDayCv';
    Result : string = this.i + 'Result';
    ResultCv : string = this.i + 'ResultCv';
    TechnicianUserId : string = this.i + 'TechnicianUserId';
    TechFirstName : string = this.i + 'TechFirstName';
    TechLastName : string = this.i + 'TechLastName';
    TechOffice : string = this.i + 'TechOffice';
    TechMobile : string = this.i + 'TechMobile';
    TechEmail : string = this.i + 'TechEmail';
    InspectionType : string = this.i + 'InspectionType';
    AvailableDates : string = this.i + 'AvailableDates';
    AdditionalNotes : string = this.i + 'AdditionalNotes';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    InspectionNotes : string = this.i + 'InspectionNotes';
    ScheduledDateTime : string = this.i + 'ScheduledDateTime';
    ScheduledNotes : string = this.i + 'ScheduledNotes';
    ResultDateTime : string = this.i + 'ResultDateTime';
    ResultNotes : string = this.i + 'ResultNotes';
    InspectionStatusId : string = this.i + 'InspectionStatusId';
    Subcontractor : string = this.i + 'Subcontractor';
    UseSub : string = this.i + 'UseSub';

    Relations = {
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'roInspections|Permitv2|PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
    };
}

export class Permits2RoPermitsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_roPermits.';

    constructor() {
        this.ItemDetail.ItemId=2779;
        this.ItemDetail.ItemName='permits2_roPermits';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitId : string = this.i + 'PermitId';
    JobId : string = this.i + 'JobId';
    JobNumberId : string = this.i + 'JobNumberId';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    InspectionNeeded : string = this.i + 'InspectionNeeded';
    HasAssociatedJobId : string = this.i + 'HasAssociatedJobId';
    JobAddress1 : string = this.i + 'JobAddress1';
    JobAddress2 : string = this.i + 'JobAddress2';
    JobCity : string = this.i + 'JobCity';
    JobCountyId : string = this.i + 'JobCountyId';
    JobCountyName : string = this.i + 'JobCountyName';
    JobStateId : string = this.i + 'JobStateId';
    JobStateName : string = this.i + 'JobStateName';
    JobStateShortName : string = this.i + 'JobStateShortName';
    JobPostalCode : string = this.i + 'JobPostalCode';
    ProjectManagerUserId : string = this.i + 'ProjectManagerUserId';
    ProjectManagerEmail : string = this.i + 'ProjectManagerEmail';
    CustomerName : string = this.i + 'CustomerName';
    ProjectManager2UserId : string = this.i + 'ProjectManager2UserId';
    JobNumJobNumberId : string = this.i + 'JobNumJobNumberId';
    JobNumAddress1 : string = this.i + 'JobNumAddress1';
    JobNumAddress2 : string = this.i + 'JobNumAddress2';
    JobNumCity : string = this.i + 'JobNumCity';
    JobNumStateId : string = this.i + 'JobNumStateId';
    JobNumStateName : string = this.i + 'JobNumStateName';
    JobNumStateShortName : string = this.i + 'JobNumStateShortName';
    JobNumPostalCode : string = this.i + 'JobNumPostalCode';
    SummaryDescription : string = this.i + 'SummaryDescription';
    JobNumber : string = this.i + 'JobNumber';
    JobSiteId : string = this.i + 'JobSiteId';
    IsActive : string = this.i + 'IsActive';
    IsComplete : string = this.i + 'IsComplete';
    ProjectManager2Email : string = this.i + 'ProjectManager2Email';
    InspDueDate : string = this.i + 'InspDueDate';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'roPermits|Ethos_JobNumber|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Job Number - Job Num Job Number */
            EthosJobNumberByJobNumJobNumberId : {
                RelationName: 'roPermits|Ethos_JobNumber|JobNumJobNumberId',
                FieldPrefix: 'JobNumEthosJobNumber',
                PropertyName: 'JobNumEthosJobNumber'
            },
            /** Relation: Ethos Opportunity - Permit */
            EthosOpportunityByPermitId : {
                RelationName: 'roPermits|Ethos_Opportunity|OpportunityId',
                FieldPrefix: 'PermitIdEthosOpportunity',
                PropertyName: 'PermitIdEthosOpportunity'
            },
            /** Relation: Ethos User - Project Manager User */
            EthosUserByProjectManagerUserId : {
                RelationName: 'roPermits|Ethos_User|ProjectManagerUserId',
                FieldPrefix: 'ProjectManagerEthosUser',
                PropertyName: 'ProjectManagerEthosUser'
            },
            /** Relation: Ethos User - Project Manager2 User */
            EthosUserByProjectManager2UserId : {
                RelationName: 'roPermits|Ethos_User|ProjectManager2UserId',
                FieldPrefix: 'ProjectManager2EthosUser',
                PropertyName: 'ProjectManager2EthosUser'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'roPermits|permits2.Permit|PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Ro Permits By Subordinates */
            RoPermitsBySubordinates : {
                RelationName: 'roPermits|roPermitsBySubordinates|PermitId',
                FieldPrefix: 'RoPermitsBySubordinates',
                PropertyName: 'RoPermitsBySubordinates'
            },
    };
}

export class RoPermitsBySubordinatesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roPermitsBySubordinates.';

    constructor() {
        this.ItemDetail.ItemId=2795;
        this.ItemDetail.ItemName='roPermitsBySubordinates';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitId : string = this.i + 'PermitId';
    RequestedByUserId : string = this.i + 'RequestedByUserId';
    ViewableBy : string = this.i + 'ViewableBy';
    ReportingLevels : string = this.i + 'ReportingLevels';

    Relations = {
            /** Relation: Ro Permits */
            Permits2RoPermits : {
                RelationName: 'roPermits|roPermitsBySubordinates|PermitId',
                FieldPrefix: 'Permits2roPermits',
                PropertyName: 'Permits2roPermits'
            },
    };
}

export class StageAuditLogMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'StageAuditLog.';

    constructor() {
        this.ItemDetail.ItemId=2796;
        this.ItemDetail.ItemName='StageAuditLog';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    StageAuditLogId : string = this.i + 'StageAuditLogId';
    PermitStatusId : string = this.i + 'PermitStatusId';
    StatusUpdatedByUserId : string = this.i + 'StatusUpdatedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    PermitId : string = this.i + 'PermitId';
    StageCompleted : string = this.i + 'StageCompleted';

    Relations = {
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'permits2_Permit|StageAuditLog|PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Permit Status */
            Permits2PermitStatus : {
                RelationName: 'permits2_PermitStatus|StageAuditLog|PermitStatusId',
                FieldPrefix: 'Permits2PermitStatus',
                PropertyName: 'Permits2PermitStatus'
            },
            /** Relation: Ethos User - Status Updated By User */
            EthosUserByStatusUpdatedByUserId : {
                RelationName: 'Ethos_User|StageAuditLog|StatusUpdatedByUserId',
                FieldPrefix: 'StatusUpdatedByEthosUser',
                PropertyName: 'StatusUpdatedByEthosUser'
            },
    };
}

export class PermitsV2MetaData {

    static Permits2AccessControl : Permits2AccessControlMetaData = new Permits2AccessControlMetaData();
    static ChangeRequest : ChangeRequestMetaData = new ChangeRequestMetaData();
    static CodeValue : CodeValueMetaData = new CodeValueMetaData();
    static EthosCodeValue : EthosCodeValueMetaData = new EthosCodeValueMetaData();
    static EthosCodeValueCustom : EthosCodeValueCustomMetaData = new EthosCodeValueCustomMetaData();
    static EthosJob : EthosJobMetaData = new EthosJobMetaData();
    static EthosJobNumber : EthosJobNumberMetaData = new EthosJobNumberMetaData();
    static EthosJobNumberForecast : EthosJobNumberForecastMetaData = new EthosJobNumberForecastMetaData();
    static EthosJobNumberMembership : EthosJobNumberMembershipMetaData = new EthosJobNumberMembershipMetaData();
    static EthosJobNumberPhase : EthosJobNumberPhaseMetaData = new EthosJobNumberPhaseMetaData();
    static EthosJobNumberPriority : EthosJobNumberPriorityMetaData = new EthosJobNumberPriorityMetaData();
    static EthosJobSite : EthosJobSiteMetaData = new EthosJobSiteMetaData();
    static EthosJobSow : EthosJobSowMetaData = new EthosJobSowMetaData();
    static EthosOpportunity : EthosOpportunityMetaData = new EthosOpportunityMetaData();
    static EthosUser : EthosUserMetaData = new EthosUserMetaData();
    static EthosUserDiff : EthosUserDiffMetaData = new EthosUserDiffMetaData();
    static EthosUserSkill : EthosUserSkillMetaData = new EthosUserSkillMetaData();
    static EthosWachterDepartment : EthosWachterDepartmentMetaData = new EthosWachterDepartmentMetaData();
    static EthosWachterTeam : EthosWachterTeamMetaData = new EthosWachterTeamMetaData();
    static EthosWorkflowStatus : EthosWorkflowStatusMetaData = new EthosWorkflowStatusMetaData();
    static EthosWorkflowStatusSet : EthosWorkflowStatusSetMetaData = new EthosWorkflowStatusSetMetaData();
    static Permits2Inspection : Permits2InspectionMetaData = new Permits2InspectionMetaData();
    static InspectionResult : InspectionResultMetaData = new InspectionResultMetaData();
    static InspectionStatus : InspectionStatusMetaData = new InspectionStatusMetaData();
    static NoteType : NoteTypeMetaData = new NoteTypeMetaData();
    static Permits2Permit : Permits2PermitMetaData = new Permits2PermitMetaData();
    static Permits2PermitPermitType : Permits2PermitPermitTypeMetaData = new Permits2PermitPermitTypeMetaData();
    static Permits2PermitStatus : Permits2PermitStatusMetaData = new Permits2PermitStatusMetaData();
    static Permits2RequiredCable : Permits2RequiredCableMetaData = new Permits2RequiredCableMetaData();
    static RoEthosUser : RoEthosUserMetaData = new RoEthosUserMetaData();
    static RoEthosUserOriginal : RoEthosUserOriginalMetaData = new RoEthosUserOriginalMetaData();
    static Permits2RoInspections : Permits2RoInspectionsMetaData = new Permits2RoInspectionsMetaData();
    static Permits2RoPermits : Permits2RoPermitsMetaData = new Permits2RoPermitsMetaData();
    static RoPermitsBySubordinates : RoPermitsBySubordinatesMetaData = new RoPermitsBySubordinatesMetaData();
    static StageAuditLog : StageAuditLogMetaData = new StageAuditLogMetaData();
}
// Generated Entity Interfaces
export interface Permits2AccessControlEntity extends DwOrmData {
    // Attributes
    AccessControlId?: number;
    AccessControlCv?: number;
    Quantity?: number;
    Description?: string;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ModifiedByEthos_UserId?: number;

    // Display Attributes
    AccessControlCvDisplay?: string;
    PermitIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    AccessControlCvCodeValue? : CodeValueEntity;
    Permits2Permit? : Permits2PermitEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface ChangeRequestEntity extends DwOrmData {
    // Attributes
    ChangeRequestId?: number;
    CreatedByUserId?: number;
    CreatedByDateTime?: string;
    NoteId?: number;
    InProgress?: boolean;
    InitialPermitStatusId?: number;
    CompletedByUserId?: number;
    CompletedOnDateTime?: string;

    // Display Attributes
    CreatedByUserIdDisplay?: string;
    NoteIdDisplay?: string;
    InitialPermitStatusIdDisplay?: string;
    CompletedByUserIdDisplay?: string;

    // Relations
    InitialPermits2PermitStatus? : Permits2PermitStatusEntity;
    CreatedByEthosUser? : EthosUserEntity;
    CompletedByEthosUser? : EthosUserEntity;
    Permits2Permit? : Permits2PermitEntity[];
}

export interface CodeValueEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
    AccessControlCvPermits2AccessControl? : Permits2AccessControlEntity[];
    PreferredTimeOfDayCvPermits2Inspection? : Permits2InspectionEntity[];
    PermitRequestTypeCvPermits2Permit? : Permits2PermitEntity[];
    CCTVInstallTypeCvPermits2Permit? : Permits2PermitEntity[];
    ElectricalDifferentTypeCvPermits2Permit? : Permits2PermitEntity[];
    ElectricalOutletTypeCvPermits2Permit? : Permits2PermitEntity[];
    ElectricalWorkTypeCvPermits2Permit? : Permits2PermitEntity[];
    FireAlarmDemoInstallCvPermits2Permit? : Permits2PermitEntity[];
    CableTypeCvPermits2RequiredCable? : Permits2RequiredCableEntity[];
}

export interface EthosCodeValueEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;
    ImagePath?: string;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
    JobCategoryCvEthosJob? : EthosJobEntity[];
    InvoiceDeliveryTypeCVEthosJobNumber? : EthosJobNumberEntity[];
    ForecastStatusCvEthosJobNumber? : EthosJobNumberEntity[];
    JobNumberTypeCvEthosJobNumber? : EthosJobNumberEntity[];
    UserTypeCvEthosUser? : EthosUserEntity[];
    // Duplicate property excluded
    // UserTypeCvEthosUser : EthosUserEntity[];
    ResourceGroupCvEthosUser? : EthosUserEntity[];
    SkillCvEthosUserSkill? : EthosUserSkillEntity[];
    DepartmentTypeCvEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    TeamTypeCvEthosWachterTeam? : EthosWachterTeamEntity[];
    PermitTeamCvPermits2Permit? : Permits2PermitEntity[];
    PlenumRiserCvPermits2Permit? : Permits2PermitEntity[];
    PermitTypeCvPermits2PermitPermitType? : Permits2PermitPermitTypeEntity[];
    PermitTypeCvPermits2RequiredCable? : Permits2RequiredCableEntity[];
    ResourceGroupCvRoEthosUser? : RoEthosUserEntity[];
    UserTypeCvRoEthosUser? : RoEthosUserEntity[];
}

export interface EthosCodeValueCustomEntity extends DwOrmData {
    // Attributes
    CodeValueCustomId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
}

export interface EthosJobEntity extends DwOrmData {
    // Attributes
    JobId?: number;
    JobNumberId?: number;
    JobEtcDateTime?: string;
    LookUpKey?: string;
    JobStatusWs?: number;
    JobStartDateTime?: string;
    ModifiedDateTime?: string;
    JobDueDateTime?: string;
    CompletedByUserId?: number;
    CompletedByDateTime?: string;
    IsTechOnSite?: boolean;
    JobCategoryCv?: number;
    JobNumberPriorityId?: number;

    // Display Attributes
    JobIdDisplay?: string;
    JobNumberIdDisplay?: string;
    JobStatusWsDisplay?: string;
    CompletedByUserIdDisplay?: string;
    JobCategoryCvDisplay?: string;
    JobNumberPriorityIdDisplay?: string;

    // Relations
    JobCategoryCvEthosCodeValue? : EthosCodeValueEntity;
    EthosJobSiteJobId? : EthosJobSiteEntity;
    EthosJobNumber? : EthosJobNumberEntity;
    EthosJobNumberPriority? : EthosJobNumberPriorityEntity;
    CompletedByEthosUser? : EthosUserEntity;
    JobStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    EthosJobNumberJobNumberId? : EthosJobNumberEntity[];
    EthosJobSite? : EthosJobSiteEntity[];
    EthosJobSow? : EthosJobSowEntity[];
    Permits2Permit? : Permits2PermitEntity[];
}

export interface EthosJobNumberEntity extends DwOrmData {
    // Attributes
    JobNumberId?: number;
    JobNumberStatusWs?: number;
    JobNumberStatus?: string;
    JobNumber?: string;
    CustomerId?: number;
    JobName?: string;
    EstimatedStartDate?: string;
    EstimatedEndDate?: string;
    ProjectMgr1UserId?: number;
    ProjectMgr2UserId?: number;
    AsstProjectMgrUserId?: number;
    SeniorMgrUserId?: number;
    LeadTech1UserId?: number;
    LeadTech2UserId?: number;
    InvoiceApproval1UserId?: number;
    InvoiceApproval2UserId?: number;
    ForecastStatusCv?: number;
    ForecastStatus?: string;
    WachterTeamId?: number;
    CustomerName?: string;
    CustomerShortName?: string;
    BillingInstructions?: string;
    ChangeOrderProcessInstructions?: string;
    PartialBilling?: boolean;
    FinalInvoiceDate?: string;
    InvoiceDeliveryTypeData?: string;
    InvoiceDeliveryTypeCV?: number;
    OpportunityId?: number;
    EndCustomerId?: number;
    LookUpKey?: number;
    IsDeleted?: boolean;
    JobNumberTypeCv?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    JobNumberStatusWsDisplay?: string;
    CustomerIdDisplay?: string;
    ProjectMgr1UserIdDisplay?: string;
    ProjectMgr2UserIdDisplay?: string;
    AsstProjectMgrUserIdDisplay?: string;
    SeniorMgrUserIdDisplay?: string;
    LeadTech1UserIdDisplay?: string;
    LeadTech2UserIdDisplay?: string;
    InvoiceApproval1UserIdDisplay?: string;
    InvoiceApproval2UserIdDisplay?: string;
    ForecastStatusCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    InvoiceDeliveryTypeCVDisplay?: string;
    OpportunityIdDisplay?: string;
    EndCustomerIdDisplay?: string;
    JobNumberTypeCvDisplay?: string;

    // Relations
    InvoiceDeliveryTypeCVEthosCodeValue? : EthosCodeValueEntity;
    ForecastStatusCvEthosCodeValue? : EthosCodeValueEntity;
    JobNumberTypeCvEthosCodeValue? : EthosCodeValueEntity;
    EthosJobJobNumberId? : EthosJobEntity;
    EthosOpportunity? : EthosOpportunityEntity;
    // Duplicate property excluded
    // EthosOpportunity : EthosOpportunityEntity;
    // Duplicate property excluded
    // EthosOpportunity : EthosOpportunityEntity;
    ProjectMgr1EthosUser? : EthosUserEntity;
    ProjectMgr2EthosUser? : EthosUserEntity;
    AsstProjectMgrEthosUser? : EthosUserEntity;
    SeniorMgrEthosUser? : EthosUserEntity;
    LeadTech1EthosUser? : EthosUserEntity;
    LeadTech2EthosUser? : EthosUserEntity;
    InvoiceApproval1EthosUser? : EthosUserEntity;
    InvoiceApproval2EthosUser? : EthosUserEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
    JobNumberStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    EthosJob? : EthosJobEntity[];
    EthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    EthosJobNumberMembership? : EthosJobNumberMembershipEntity[];
    EthosJobNumberPhase? : EthosJobNumberPhaseEntity[];
    EthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    UserIdEthosUser? : EthosUserEntity[];
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    OverheadEthosWachterTeam? : EthosWachterTeamEntity[];
    Permits2Permit? : Permits2PermitEntity[];
    // Duplicate property excluded
    // Permits2Permit : Permits2PermitEntity[];
    Permits2roPermits? : Permits2RoPermitsEntity[];
    JobNumPermits2roPermits? : Permits2RoPermitsEntity[];
}

export interface EthosJobNumberForecastEntity extends DwOrmData {
    // Attributes
    JobNumberForecastId?: number;
    JobNumberId?: number;
    YeProjectedCosts?: number;
    YeProjectedRevenue?: number;
    IsDeleted?: boolean;
    CreatedBy?: number;
    ModifiedBy?: number;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    Notes?: string;
    NoteAgingOverSixtyDays?: string;
    NoteOverUnderBilling?: string;
    NoteLowForecastedGpm?: string;
    NoteChangedGpm?: string;
    AXIntegrationID?: string;
    TotalForecastRevenue?: number;
    TotalForecastCost?: number;
    LookUpKey?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
}

export interface EthosJobNumberMembershipEntity extends DwOrmData {
    // Attributes
    JobNumberMembershipId?: number;
    UserId?: number;
    JobNumberId?: number;

    // Display Attributes
    UserIdDisplay?: string;
    JobNumberIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    EthosUser? : EthosUserEntity;
}

export interface EthosJobNumberPhaseEntity extends DwOrmData {
    // Attributes
    JobNumberPhaseId?: number;
    JobNumberId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsActive?: boolean;
    IsVisible?: boolean;
    IsOnSite?: boolean;
    IsEstimate?: boolean;
    JobNumberPhaseStatusWs?: number;
    WorkflowStatusDisplay?: string;
    LookUpKey?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    JobNumberPhaseStatusWsDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    JobNumberPhaseStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    OverheadEthosWachterTeam? : EthosWachterTeamEntity[];
}

export interface EthosJobNumberPriorityEntity extends DwOrmData {
    // Attributes
    JobNumberPriorityId?: number;
    JobNumberId?: number;
    PriorityName?: string;
    IsDeleted?: boolean;
    ResponseTimeInHours?: number;
    StraightHourlyBillingRate?: number;
    OvertimeHourlyBillingRate?: number;
    HolidayHourlyBillingRate?: number;
    TravelHourlyBillingRate?: number;
    MileageBillingRate?: number;
    MaxTravelInHours?: number;
    CreatedDateTime?: string;
    CreatedByUserId?: number;
    ModifiedDateTime?: string;
    ModifiedByUserId?: number;
    TripCharge?: number;
    ExpediteFee?: number;
    IsEscalationEnabled?: boolean;
    SendPriorityNotification?: boolean;

    // Display Attributes
    JobNumberIdDisplay?: string;
    CreatedByUserIdDisplay?: string;
    ModifiedByUserIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    EthosJob? : EthosJobEntity[];
}

export interface EthosJobSiteEntity extends DwOrmData {
    // Attributes
    JobSiteId?: number;
    JobId?: number;
    SiteId?: number;
    IsDeleted?: boolean;
    LookUpKey?: string;
    SubJobNumber?: string;
    FullJobNumber?: string;

    // Display Attributes
    JobIdDisplay?: string;
    SiteIdDisplay?: string;

    // Relations
    EthosJob? : EthosJobEntity;
    EthosJobJobId? : EthosJobEntity[];
    EthosJobSow? : EthosJobSowEntity[];
    Permits2Permit? : Permits2PermitEntity[];
}

export interface EthosJobSowEntity extends DwOrmData {
    // Attributes
    JobSowId?: number;
    SowId?: number;
    JobId?: number;
    JobSiteId?: number;
    LookUpKey?: string;

    // Display Attributes
    SowIdDisplay?: string;
    JobIdDisplay?: string;
    JobSiteIdDisplay?: string;

    // Relations
    EthosJob? : EthosJobEntity;
    EthosJobSite? : EthosJobSiteEntity;
}

export interface EthosOpportunityEntity extends DwOrmData {
    // Attributes
    OpportunityId?: number;
    OpportunityStatusWs?: number;
    OpportunityName?: string;
    CustomerId?: number;
    ProjectManagerUserId?: number;
    OpportunityManagerUserId?: number;
    ProjectStatusWs?: number;
    StartDate?: string;
    StopDate?: string;

    // Display Attributes
    OpportunityStatusWsDisplay?: string;
    CustomerIdDisplay?: string;
    ProjectManagerUserIdDisplay?: string;
    OpportunityManagerUserIdDisplay?: string;
    ProjectStatusWsDisplay?: string;

    // Relations
    OpportunityManagerEthosUser? : EthosUserEntity;
    ProjectManagerEthosUser? : EthosUserEntity;
    OpportunityStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    EthosJobNumber? : EthosJobNumberEntity[];
    // Duplicate property excluded
    // EthosJobNumber : EthosJobNumberEntity[];
    // Duplicate property excluded
    // EthosJobNumber : EthosJobNumberEntity[];
    PermitIdPermits2roPermits? : Permits2RoPermitsEntity[];
}

export interface EthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    CustomerId?: number;
    SubcontractorId?: number;
    SpecialInstructions?: string;
    isVaxxed?: boolean;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    CustomerIdDisplay?: string;

    // Relations
    UserTypeCvEthosCodeValue? : EthosCodeValueEntity;
    // Duplicate property excluded
    // UserTypeCvEthosCodeValue : EthosCodeValueEntity;
    ResourceGroupCvEthosCodeValue? : EthosCodeValueEntity;
    UserIdEthosJobNumber? : EthosJobNumberEntity;
    SupervisorEthosUser? : EthosUserEntity;
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    EthosWachterTeam? : EthosWachterTeamEntity;
    UserStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    CreatedByEthosPermits2AccessControl? : Permits2AccessControlEntity[];
    ModifiedByEthosPermits2AccessControl? : Permits2AccessControlEntity[];
    CreatedByChangeRequest? : ChangeRequestEntity[];
    CompletedByChangeRequest? : ChangeRequestEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
    CompletedByEthosJob? : EthosJobEntity[];
    ProjectMgr1EthosJobNumber? : EthosJobNumberEntity[];
    ProjectMgr2EthosJobNumber? : EthosJobNumberEntity[];
    AsstProjectMgrEthosJobNumber? : EthosJobNumberEntity[];
    SeniorMgrEthosJobNumber? : EthosJobNumberEntity[];
    LeadTech1EthosJobNumber? : EthosJobNumberEntity[];
    LeadTech2EthosJobNumber? : EthosJobNumberEntity[];
    InvoiceApproval1EthosJobNumber? : EthosJobNumberEntity[];
    InvoiceApproval2EthosJobNumber? : EthosJobNumberEntity[];
    CreatedByEthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    ModifiedByEthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    EthosJobNumberMembership? : EthosJobNumberMembershipEntity[];
    CreatedByEthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    ModifiedByEthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    OpportunityManagerEthosOpportunity? : EthosOpportunityEntity[];
    ProjectManagerEthosOpportunity? : EthosOpportunityEntity[];
    EthosEthosUserDiff? : EthosUserDiffEntity[];
    EthosUserSkill? : EthosUserSkillEntity[];
    DepartmentDirectorEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    DepartmentManagerEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    DepartmentAsstManagerEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    TeamLeaderEthosWachterTeam? : EthosWachterTeamEntity[];
    CreatedByPermits2Inspection? : Permits2InspectionEntity[];
    TechnicianPermits2Inspection? : Permits2InspectionEntity[];
    CreatedByPermits2Permit? : Permits2PermitEntity[];
    ModifiedByPermits2Permit? : Permits2PermitEntity[];
    RequestedByPermits2Permit? : Permits2PermitEntity[];
    AssignedToPermits2Permit? : Permits2PermitEntity[];
    CreatedByEthosPermits2RequiredCable? : Permits2RequiredCableEntity[];
    ModifiedByEthosPermits2RequiredCable? : Permits2RequiredCableEntity[];
    RoEthosUser? : RoEthosUserEntity;
    SupervisorRoEthosUser? : RoEthosUserEntity[];
    ProjectManagerPermits2roPermits? : Permits2RoPermitsEntity[];
    ProjectManager2Permits2roPermits? : Permits2RoPermitsEntity[];
    StatusUpdatedByStageAuditLog? : StageAuditLogEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
}

export interface EthosUserDiffEntity extends DwOrmData {
    // Attributes
    Ethos_UserDiffId?: number;
    Ethos_UserId?: number;
    FieldName?: string;
    OldValue?: string;
    NewValue?: string;
    ChangedDateTime?: string;

    // Display Attributes
    Ethos_UserIdDisplay?: string;

    // Relations
    EthosEthosUser? : EthosUserEntity;
}

export interface EthosUserSkillEntity extends DwOrmData {
    // Attributes
    UserSkillId?: number;
    UserId?: number;
    SkillCv?: number;
    Meaning?: string;
    Display?: string;

    // Display Attributes
    UserIdDisplay?: string;
    SkillCvDisplay?: string;

    // Relations
    SkillCvEthosCodeValue? : EthosCodeValueEntity;
    EthosUser? : EthosUserEntity;
}

export interface EthosWachterDepartmentEntity extends DwOrmData {
    // Attributes
    WachterDepartmentId?: number;
    DepartmentTypeCv?: number;
    DepartmentTypeMeaning?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    DepartmentDirectorUserId?: number;
    IsDeleted?: boolean;
    DepartmentManagerUserId?: number;
    DepartmentAsstManagerUserId?: number;
    JobNumberId?: number;
    AxIntegrationId?: string;
    JobNumberPhaseId?: number;
    RowInsertDateTime?: string;

    // Display Attributes
    DepartmentTypeCvDisplay?: string;
    DepartmentDirectorUserIdDisplay?: string;
    DepartmentManagerUserIdDisplay?: string;
    DepartmentAsstManagerUserIdDisplay?: string;
    JobNumberIdDisplay?: string;
    JobNumberPhaseIdDisplay?: string;

    // Relations
    DepartmentTypeCvEthosCodeValue? : EthosCodeValueEntity;
    EthosJobNumber? : EthosJobNumberEntity;
    EthosJobNumberPhase? : EthosJobNumberPhaseEntity;
    DepartmentDirectorEthosUser? : EthosUserEntity;
    DepartmentManagerEthosUser? : EthosUserEntity;
    DepartmentAsstManagerEthosUser? : EthosUserEntity;
    EthosUser? : EthosUserEntity;
    EthosWachterTeam? : EthosWachterTeamEntity[];
    RoEthosUser? : RoEthosUserEntity[];
}

export interface EthosWachterTeamEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    TeamTypeCv?: number;
    TeamTypeMeaning?: string;
    TeamName?: string;
    TeamLeaderUserId?: number;
    AxIntegrationId?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    IsDeleted?: boolean;
    OverheadJobNumberId?: number;
    OverheadJobNumberPhaseId?: number;
    RowInsertDateTime?: string;

    // Display Attributes
    WachterDepartmentIdDisplay?: string;
    TeamTypeCvDisplay?: string;
    TeamLeaderUserIdDisplay?: string;
    OverheadJobNumberIdDisplay?: string;
    OverheadJobNumberPhaseIdDisplay?: string;

    // Relations
    TeamTypeCvEthosCodeValue? : EthosCodeValueEntity;
    OverheadEthosJobNumber? : EthosJobNumberEntity;
    OverheadEthosJobNumberPhase? : EthosJobNumberPhaseEntity;
    TeamLeaderEthosUser? : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
    EthosJobNumber? : EthosJobNumberEntity[];
    EthosUser? : EthosUserEntity[];
    RoEthosUser? : RoEthosUserEntity[];
}

export interface EthosWorkflowStatusEntity extends DwOrmData {
    // Attributes
    WorkflowStatusId?: number;
    WorkflowStatusSetId?: number;
    WorkflowStatus?: string;
    WorkflowStatusMeaning?: string;
    WorkflowStatusOrder?: number;
    IsActive?: boolean;
    WorkflowStatusShortName?: string;

    // Display Attributes
    WorkflowStatusSetIdDisplay?: string;

    // Relations
    EthosWorkflowStatusSet? : EthosWorkflowStatusSetEntity;
    JobStatusWsEthosJob? : EthosJobEntity[];
    JobNumberStatusWsEthosJobNumber? : EthosJobNumberEntity[];
    JobNumberPhaseStatusWsEthosJobNumberPhase? : EthosJobNumberPhaseEntity[];
    OpportunityStatusWsEthosOpportunity? : EthosOpportunityEntity[];
    UserStatusWsEthosUser? : EthosUserEntity[];
    UserStatusWsRoEthosUser? : RoEthosUserEntity[];
}

export interface EthosWorkflowStatusSetEntity extends DwOrmData {
    // Attributes
    WorkflowStatusSetId?: number;
    WorkflowStatusSetName?: string;
    MetaDataItemId?: number;
    MetaDataAttributeId?: number;
    RelatedCodeSetId?: number;
    UseTransitions?: boolean;
    IsActive?: boolean;


    // Relations
    EthosWorkflowStatus? : EthosWorkflowStatusEntity[];
}

export interface Permits2InspectionEntity extends DwOrmData {
    // Attributes
    InspectionId?: number;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByUserId?: number;
    InspectionType?: string;
    TechnicianUserId?: number;
    AvailableDates?: string;
    PreferredTimeOfDayCv?: number;
    AdditionalNotes?: string;
    InspectionNotes?: string;
    ScheduledDateTime?: string;
    ScheduledNotes?: string;
    ResultCv?: number;
    ResultDateTime?: string;
    ResultNotes?: string;
    InspectionStatusId?: number;
    SyncStatus?: boolean;
    Subcontractor?: string;
    UseSub?: boolean;

    // Display Attributes
    PermitIdDisplay?: string;
    CreatedByUserIdDisplay?: string;
    TechnicianUserIdDisplay?: string;
    PreferredTimeOfDayCvDisplay?: string;
    ResultCvDisplay?: string;
    InspectionStatusIdDisplay?: string;

    // Relations
    PreferredTimeOfDayCvCodeValue? : CodeValueEntity;
    ResultCvInspectionResult? : InspectionResultEntity;
    InspectionStatus? : InspectionStatusEntity;
    Permits2Permit? : Permits2PermitEntity;
    CreatedByEthosUser? : EthosUserEntity;
    TechnicianEthosUser? : EthosUserEntity;
}

export interface InspectionResultEntity extends DwOrmData {
    // Attributes
    InspectionResultId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    Order?: number;
    IsActive?: boolean;


    // Relations
    ResultCvPermits2Inspection? : Permits2InspectionEntity[];
}

export interface InspectionStatusEntity extends DwOrmData {
    // Attributes
    InspectionStatusId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    Order?: number;
    IsActive?: boolean;


    // Relations
    Permits2Inspection? : Permits2InspectionEntity[];
}

export interface NoteTypeEntity extends DwOrmData {
    // Attributes
    NoteTypeId?: number;
    NoteType?: string;
    MetaDataLookupId?: number;


    // Relations
}

export interface Permits2PermitEntity extends DwOrmData {
    // Attributes
    PermitId?: number;
    LegacyPermitRequestId?: number;
    LegacyPermitId?: number;
    CreatedByUserId?: number;
    ModifiedByUserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    PermitRequestTypeCv?: number;
    PermitTeamCv?: number;
    RushRequested?: boolean;
    DueDate?: string;
    RequestedByUserId?: number;
    EmailCopyString?: string;
    AssignedToUserId?: number;
    FollowUpDate?: string;
    IsLicenceRequired?: boolean;
    HasLicenseFile?: boolean;
    FollowUpDescription?: string;
    EstimatedStartDate?: string;
    EstimatedCompletionDate?: string;
    JobId?: number;
    JobSiteId?: number;
    Jurisdiction?: string;
    NoteParentId?: number;
    PerformingWorkCv?: number;
    SubContractorLicenseNumber?: string;
    CardReader?: boolean;
    CardReaderQuantity?: number;
    Paging?: boolean;
    IsTyingIntoFireAlarm?: boolean;
    VoiceDataPlenumRated?: boolean;
    DataVoiceUsingExisting?: boolean;
    DataVoiceReplacingCable?: boolean;
    DataVoiceNewCable?: boolean;
    CCTVPlenumRated?: boolean;
    HasCameras?: boolean;
    CamerasQuantity?: number;
    CCTVUsingExisting?: boolean;
    CCTVReplacingCable?: boolean;
    CCTVNewCable?: boolean;
    CCTVInstallTypeCv?: number;
    CCTVOtherInstallType?: string;
    AudioPlenumRated?: boolean;
    HasSpeakers?: boolean;
    SpeakersQuantity?: number;
    IsSwappingOutPanel?: boolean;
    IsNewFireSystem?: boolean;
    FireAlarmInitiatingDevices?: number;
    FireAlarmDemoInstallCv?: number;
    FireAlarmInstallRadio?: boolean;
    OutletQuantity?: number;
    TotalAmps?: number;
    PanelsQuantity?: number;
    CircuitsQuantity?: number;
    ElectricalOutletTypeCv?: number;
    ElectricalOtherOutletType?: string;
    ElectricalWorkTypeCv?: number;
    ElectricalOtherWorkType?: string;
    ElectricalDifferentTypeCv?: number;
    ElectricalOtherDifferentType?: string;
    IsLicensedTechnician?: boolean;
    TechnicianNameAndLicenseNumber?: string;
    ElectricalTotalVoltage?: number;
    HasPanelInstallation?: boolean;
    BurglarAlarmPanelQuantity?: number;
    BurglarAlarmDeviceType?: string;
    NumberOfRooms?: number;
    FloorCount?: number;
    PlenumRiserCv?: number;
    HasUndergroundCabling?: boolean;
    HasCableInConduit?: boolean;
    GCPresent?: boolean;
    GCName?: string;
    GCPermitNumber?: string;
    ValuationOverallContract?: number;
    ValuationOverallSOW?: number;
    NewConstruction?: boolean;
    ExistingBuilding?: boolean;
    CountOfNac?: number;
    FacilityFootage?: number;
    WorkplaceFootage?: number;
    ScopeOfWork?: string;
    MergeDeleted?: boolean;
    PropertyOwnerName?: string;
    PropertyOwnerCity?: string;
    PropertyOwnerStateId?: number;
    PropertyOwnerPostalCode?: string;
    PropertyOwnerAddress?: string;
    PermitCost?: number;
    CanBePulledOnline?: boolean;
    WachterPermitNumber?: string;
    ExpirationDate?: string;
    InfoNeededNote?: string;
    FilesInSharepoint?: boolean;
    SharepointId?: number;
    PermitStatusId?: number;
    MediaGroupId?: number;
    SubPanelQuantity?: number;
    FixtureQuantity?: number;
    AdditionalNotesElectrical?: string;
    CountAdditionalDevicesFire?: number;
    AdditionalDeviceDescriptionFire?: string;
    CountAdditionalDevicesBurglar?: number;
    AdditionalDeviceDescriptionBurglar?: string;
    CompleteDate?: string;
    TechnicianOnSite?: boolean;
    PermitRequired?: boolean;
    HasExceptions?: boolean;
    InspectionRequired?: boolean;
    ApplyForPermit?: boolean;
    JobNumberId?: number;
    JobNumberAddress1?: string;
    JobNumberAddress2?: string;
    JobNumberCity?: string;
    JobNumberStateProvinceId?: number;
    JobNumberPostalCode?: string;
    ChangeRequestId?: number;

    // Display Attributes
    PermitIdDisplay?: string;
    CreatedByUserIdDisplay?: string;
    ModifiedByUserIdDisplay?: string;
    PermitRequestTypeCvDisplay?: string;
    PermitTeamCvDisplay?: string;
    RequestedByUserIdDisplay?: string;
    AssignedToUserIdDisplay?: string;
    JobIdDisplay?: string;
    JobSiteIdDisplay?: string;
    NoteParentIdDisplay?: string;
    PerformingWorkCvDisplay?: string;
    CCTVInstallTypeCvDisplay?: string;
    FireAlarmDemoInstallCvDisplay?: string;
    ElectricalOutletTypeCvDisplay?: string;
    ElectricalWorkTypeCvDisplay?: string;
    ElectricalDifferentTypeCvDisplay?: string;
    PlenumRiserCvDisplay?: string;
    PropertyOwnerStateIdDisplay?: string;
    PermitStatusIdDisplay?: string;
    JobNumberIdDisplay?: string;
    JobNumberStateProvinceIdDisplay?: string;
    ChangeRequestIdDisplay?: string;

    // Relations
    ChangeRequest? : ChangeRequestEntity;
    PermitRequestTypeCvCodeValue? : CodeValueEntity;
    CCTVInstallTypeCvCodeValue? : CodeValueEntity;
    ElectricalDifferentTypeCvCodeValue? : CodeValueEntity;
    ElectricalOutletTypeCvCodeValue? : CodeValueEntity;
    ElectricalWorkTypeCvCodeValue? : CodeValueEntity;
    FireAlarmDemoInstallCvCodeValue? : CodeValueEntity;
    PermitTeamCvEthosCodeValue? : EthosCodeValueEntity;
    PlenumRiserCvEthosCodeValue? : EthosCodeValueEntity;
    EthosJob? : EthosJobEntity;
    EthosJobNumber? : EthosJobNumberEntity;
    // Duplicate property excluded
    // EthosJobNumber : EthosJobNumberEntity;
    EthosJobSite? : EthosJobSiteEntity;
    Permits2roPermits? : Permits2RoPermitsEntity;
    Permits2PermitStatus? : Permits2PermitStatusEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    RequestedByEthosUser? : EthosUserEntity;
    AssignedToEthosUser? : EthosUserEntity;
    Permits2AccessControl? : Permits2AccessControlEntity[];
    Permits2Inspection? : Permits2InspectionEntity[];
    Permits2PermitPermitType? : Permits2PermitPermitTypeEntity[];
    Permits2RequiredCable? : Permits2RequiredCableEntity[];
    Permits2roInspections? : Permits2RoInspectionsEntity[];
    StageAuditLog? : StageAuditLogEntity[];
}

export interface Permits2PermitPermitTypeEntity extends DwOrmData {
    // Attributes
    PermitPermitTypeId?: number;
    PermitId?: number;
    PermitTypeCv?: number;

    // Display Attributes
    PermitIdDisplay?: string;
    PermitTypeCvDisplay?: string;

    // Relations
    PermitTypeCvEthosCodeValue? : EthosCodeValueEntity;
    Permits2Permit? : Permits2PermitEntity;
}

export interface Permits2PermitStatusEntity extends DwOrmData {
    // Attributes
    PermitStatusId?: number;
    PermitStatusDisplay?: string;
    PermitStatusMeaning?: string;
    PermitStatusOrder?: number;
    IsActive?: boolean;
    PermitStatusShortName?: string;


    // Relations
    InitialChangeRequest? : ChangeRequestEntity[];
    Permits2Permit? : Permits2PermitEntity[];
    StageAuditLog? : StageAuditLogEntity[];
}

export interface Permits2RequiredCableEntity extends DwOrmData {
    // Attributes
    RequiredCableId?: number;
    CableTypeCv?: number;
    Quantity?: number;
    Description?: string;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    PermitTypeCv?: number;

    // Display Attributes
    CableTypeCvDisplay?: string;
    PermitIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    PermitTypeCvDisplay?: string;

    // Relations
    PermitTypeCvEthosCodeValue? : EthosCodeValueEntity;
    CableTypeCvCodeValue? : CodeValueEntity;
    Permits2Permit? : Permits2PermitEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface RoEthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    NameLastFirstPreferedType?: string;
    IsActive?: number;
    SpecialInstructions?: string;
    BirthMonthDate?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    Company?: string;
    LicenseCount?: number;
    AXId?: string;
    YrsService?: number;
    StaffingAgencyName?: string;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    TerritoryIdDisplay?: string;

    // Relations
    ResourceGroupCvEthosCodeValue? : EthosCodeValueEntity;
    UserTypeCvEthosCodeValue? : EthosCodeValueEntity;
    SupervisorRoEthosUser? : RoEthosUserEntity;
    EthosUser? : EthosUserEntity;
    SupervisorEthosUser? : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
    UserStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    // Duplicate property excluded
    // SupervisorRoEthosUser : RoEthosUserEntity[];
}

export interface RoEthosUserOriginalEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    AXId?: string;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    EmployeeType?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    BirthMonthDate?: string;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsActive?: number;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentFileKey?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    StateProvinceShortName?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    SpecialInstructions?: string;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    Company?: number;
    LicenseCount?: number;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    NameLastFirstPreferedType?: string;


    // Relations
}

export interface Permits2RoInspectionsEntity extends DwOrmData {
    // Attributes
    InspectionId?: number;
    PreferredTimeOfDay?: string;
    PreferredTimeOfDayCv?: number;
    Result?: string;
    ResultCv?: number;
    TechnicianUserId?: number;
    TechFirstName?: string;
    TechLastName?: string;
    TechOffice?: string;
    TechMobile?: string;
    TechEmail?: string;
    InspectionType?: string;
    AvailableDates?: string;
    AdditionalNotes?: string;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByUserId?: number;
    InspectionNotes?: string;
    ScheduledDateTime?: string;
    ScheduledNotes?: string;
    ResultDateTime?: string;
    ResultNotes?: string;
    InspectionStatusId?: number;
    Subcontractor?: string;
    UseSub?: boolean;

    // Display Attributes
    PreferredTimeOfDayCvDisplay?: string;
    ResultCvDisplay?: string;
    TechnicianUserIdDisplay?: string;
    PermitIdDisplay?: string;
    CreatedByUserIdDisplay?: string;
    InspectionStatusIdDisplay?: string;

    // Relations
    Permits2Permit? : Permits2PermitEntity;
}

export interface Permits2RoPermitsEntity extends DwOrmData {
    // Attributes
    PermitId?: number;
    JobId?: number;
    JobNumberId?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    WachterDivisionId?: number;
    InspectionNeeded?: boolean;
    HasAssociatedJobId?: boolean;
    JobAddress1?: string;
    JobAddress2?: string;
    JobCity?: string;
    JobCountyId?: number;
    JobCountyName?: string;
    JobStateId?: number;
    JobStateName?: string;
    JobStateShortName?: string;
    JobPostalCode?: string;
    ProjectManagerUserId?: number;
    ProjectManagerEmail?: string;
    CustomerName?: string;
    ProjectManager2UserId?: number;
    JobNumJobNumberId?: number;
    JobNumAddress1?: string;
    JobNumAddress2?: string;
    JobNumCity?: string;
    JobNumStateId?: number;
    JobNumStateName?: string;
    JobNumStateShortName?: string;
    JobNumPostalCode?: string;
    SummaryDescription?: string;
    JobNumber?: string;
    JobSiteId?: number;
    IsActive?: boolean;
    IsComplete?: boolean;
    ProjectManager2Email?: string;
    InspDueDate?: string;

    // Display Attributes
    PermitIdDisplay?: string;
    JobIdDisplay?: string;
    JobNumberIdDisplay?: string;
    JobStateIdDisplay?: string;
    ProjectManagerUserIdDisplay?: string;
    ProjectManager2UserIdDisplay?: string;
    JobNumJobNumberIdDisplay?: string;
    JobSiteIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    JobNumEthosJobNumber? : EthosJobNumberEntity;
    PermitIdEthosOpportunity? : EthosOpportunityEntity;
    ProjectManagerEthosUser? : EthosUserEntity;
    ProjectManager2EthosUser? : EthosUserEntity;
    Permits2Permit? : Permits2PermitEntity[];
    RoPermitsBySubordinates? : RoPermitsBySubordinatesEntity[];
}

export interface RoPermitsBySubordinatesEntity extends DwOrmData {
    // Attributes
    PermitId?: number;
    RequestedByUserId?: number;
    ViewableBy?: number;
    ReportingLevels?: number;

    // Display Attributes
    PermitIdDisplay?: string;

    // Relations
    Permits2roPermits? : Permits2RoPermitsEntity;
}

export interface StageAuditLogEntity extends DwOrmData {
    // Attributes
    StageAuditLogId?: number;
    PermitStatusId?: number;
    StatusUpdatedByUserId?: number;
    CreatedByDateTime?: string;
    PermitId?: number;
    StageCompleted?: string;

    // Display Attributes
    PermitStatusIdDisplay?: string;
    StatusUpdatedByUserIdDisplay?: string;
    PermitIdDisplay?: string;

    // Relations
    Permits2Permit? : Permits2PermitEntity;
    Permits2PermitStatus? : Permits2PermitStatusEntity;
    StatusUpdatedByEthosUser? : EthosUserEntity;
}

    // Lookup Value Enums  {
export enum CodeValuePermitType {
        AccessControl = 103818,
        AudioVisual = 103819,
        BurglarAlarm = 103820,
        DataVoice = 103821,
        Electrical = 103822,
        FireAlarm = 103823,
        CCTV = 103838,
    }

// Excluding lookup PermitPermitType All Items because it contains 10000 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum CodeValuePayJobChangeType {
        SalaryChange = 161,
        WageChange = 163,
        WageToSalary = 164,
        SalaryToWage = 165,
    }

export enum CodeValueTermResignType {
        CareerChange = 168,
        CorporateRestructuring = 169,
        ExcessiveTravel = 170,
        LackOfWork = 171,
        MaternityLeave = 172,
        Personal = 173,
        ReductionInStaff = 174,
        Relocation = 175,
        Retirement = 176,
        School = 177,
        TookHigherPayingJob = 178,
        WorkSchedule = 179,
        Absenteeism = 180,
        GrossMisconduct = 181,
        Insubordination = 182,
        NeverStarted = 183,
        NoCallNoShow = 184,
        NoContact = 185,
        PolicyViolation = 186,
        PoorPerformance = 187,
        QuitWithoutNotice = 188,
        SafetyViolation = 189,
        SubstanceAbuse = 190,
        WalkedOffJob = 191,
        PassedAway = 192,
    }

export enum CodeValueMemoOfRecordEmployeeType {
        WachterAndStaffing = 78,
        Subcontractor = 81,
    }

export enum CodeValueMemoOfRecordIssueType {
        Safety = 22,
        Professionalism = 23,
        Theft = 24,
        Harassment = 25,
        Kudos = 26,
        WAM = 27,
        DOT = 28,
        Mentionable = 29,
        AccountingHR = 80,
    }

    // Error loading lookup values for Code Value - MOR SubType - By Issue Type(1513
export enum CodeValueMemoOfRecordIssueSubTypeAll {
        PPE = 30,
        HLI = 31,
        JHA = 32,
        VehicleAccident = 33,
        JobSiteAccident = 34,
        DriverAlert = 35,
        Insubordination = 36,
        Appearance = 37,
        MissedETA = 38,
        Quality = 39,
        Communication = 40,
        LossDamageOfCompanyProperty = 41,
        PolicyProcessProcedure = 42,
        WorkEthic = 43,
        Other = 44,
        OfficeHours = 45,
        Sexual = 46,
        Physical = 47,
        Verbal = 48,
        // Duplicate property Name found
        Other_49 = 49,
        Kudos = 50,
        Num11HoursTravel = 51,
        Num14HoursWorked = 52,
        Num70HoursWorked = 53,
        RequiredBreak = 54,
        FailedCheckpoint = 55,
        FailureToReportCheckpoint = 56,
        FailureToSubmitLogs = 57,
        ParkingViolation = 58,
        Mileage = 59,
        Labor = 60,
        PerDiem = 61,
        MisuseOfCompanyPhoneComputer = 62,
        NoCallNoShow = 63,
        ScopeDeviation = 64,
        RedLightViolation = 65,
        MovingViolation = 66,
        Num16HoursWorked = 67,
        SkillSetKnowledge = 68,
        CustomerApplication = 86,
        ContractReviewStorage = 87,
        WAM = 120,
        LessonsLearned = 121,
        RiskRegister = 122,
        CustomerPropery = 123,
        WachterProperty = 124,
    }

export enum CodeValueAccidentType {
        HitAndRun = 203,
        Moving = 204,
        NotAtFault = 205,
        ParkingLot = 206,
        Wildlife = 207,
        BreakIn = 335,
        Incident = 341,
        NearMiss = 342,
    }

export enum CodeValueTechType {
        Service = 141,
        Project = 142,
        Installation = 143,
        Alarm = 144,
        PhysicalSecurity = 145,
        CCTV = 146,
        AccessControl = 147,
        LBUTech = 148,
        Helper = 242,
    }

export enum CodeValueBusinessPlanReviewAccidentType {
        Vehicle = 138,
        Onsite = 140,
    }

export enum CodeValueTravelType {
        CustomerVisit = 251,
        JobSiteCheckup = 252,
        SiteWalkSurvey = 253,
        BillableLabor = 254,
        Other = 255,
    }

export enum CodeValueWorksiteType {
        OSHA = 292,
        MSHA = 293,
    }

export enum CodeValueAccidentTypeWorkplace {
        Accident = 294,
        NearMiss = 295,
        PropertyDamage = 296,
        IncidentOnly = 297,
    }

export enum CodeValueInjuryType {
        Abraision = 322,
        Burn = 323,
        Concussion = 324,
        Contusion = 325,
        ForeignBody = 326,
        Fracture = 327,
        Inhalation = 328,
        Laceration = 329,
        MuscleStrain = 330,
        Other = 331,
        Puncture = 332,
        Shock = 333,
        Sprain = 334,
    }

export enum EthosUserTypeCodeValue {
        Wachter = 497,
        Customer = 540,
        Subcontractor = 541,
        ContractStaffing = 2626,
        ThirdPartyCustomer = 102653,
    }

export enum CodeValueWorkerType {
        Wachter = 103834,
        Subcontractor = 103835,
    }

export enum CodeValuePermitRequestType {
        PermitResearch = 349,
        PermitApplication = 350,
        PermitApplicationAndResearch = 351,
    }

export enum CodeValuePermitCableType {
        Cat5e = 352,
        Cat6 = 353,
        Fiber = 354,
        Other = 367,
        Cat6a = 389,
    }

export enum PermitJobTypeLookup {
        WJID = 365,
        Opportunity = 366,
        JobNumber = 394,
    }

export enum NoteTypeAllItems {
        Default = 1,
        Permits = 2,
        PermitUpdateRequest = 3,
        PermitInfoFromPM = 4,
        StarRatings = 5,
        PermitInspectionNeeded = 6,
        PermitRequest = 7,
        PermitsV2 = 8,
        WorkersCompClaim = 9,
        CompanyLicense = 10,
        ChangeRequest = 11,
    }

export enum CodeValuePermitRequestElectricalOutletType {
        Duplex = 368,
        Quad = 369,
        Other = 370,
    }

// Excluding lookup Code Value - Different Type of Electrical because it contains 416 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum CodeValueTypesOfElectrical {
        SinglePoleSwitch = 371,
        PowerPole = 372,
        OtherOutletType = 373,
    }

export enum CodeValueElectricalNewWorkType {
        NewAddition = 377,
        NewAlteration = 378,
        OtherWorkType = 379,
    }

export enum CodeValueCCTVTypesOfInstall {
        CamerasCable = 385,
        Cameras = 386,
        Cable = 387,
        Other = 388,
    }

export enum PermitRequestJobTypeLookupNoJobNumber {
        WJID = 365,
        Opportunity = 366,
    }

export enum CodeValueJobType {
        WJID = 365,
        Opportunity = 366,
        JobNumber = 394,
    }

export enum Permitv2JobTypeLookupNoJobNumber {
        WJID = 365,
        Opportunity = 366,
    }

export enum CodeValueEthosJobNumberType {
        JobNumber = 2579,
        Holiday = 2583,
        FloatingHoliday = 2584,
        Vacation = 2585,
        Overhead = 2640,
        Sick = 102578,
        Estimation = 102849,
        Bereavement = 102982,
        Leave = 103010,
        Pending = 103757,
    }

export enum ProjectKickoffBillingType {
        Parent = 103926,
        Child = 103927,
        Neither = 103931,
    }

export enum CodeValueInspectionTimeOfDay {
        Mornings = 397,
        Afternoons = 398,
        NoPreference = 399,
    }

export enum CodeValueInspectionState {
        AllowInitialInspection = 400,
        AdditionalInspectionsNeeded = 401,
        AllInspectionsComplete = 402,
    }

export enum CodeValueInspectionResults {
        Pass = 403,
        Fail = 404,
    }

export enum InspectionAllItems {
        FinalInspection = 1,
        Final = 2,
        LowVoltage = 3,
        // Duplicate property Name found
        LowVoltage_4 = 4,
        // Duplicate property Name found
        LowVoltage_5 = 5,
        // Duplicate property Name found
        LowVoltage_6 = 6,
        // Duplicate property Name found
        LowVoltage_7 = 7,
        // Duplicate property Name found
        LowVoltage_8 = 8,
        // Duplicate property Name found
        LowVoltage_9 = 9,
        // Duplicate property Name found
        LowVoltage_10 = 10,
        // Duplicate property Name found
        LowVoltage_11 = 11,
        // Duplicate property Name found
        LowVoltage_12 = 12,
        // Duplicate property Name found
        LowVoltage_13 = 13,
        // Duplicate property Name found
        LowVoltage_14 = 14,
        // Duplicate property Name found
        LowVoltage_15 = 15,
        // Duplicate property Name found
        LowVoltage_16 = 16,
        // Duplicate property Name found
        LowVoltage_17 = 17,
        RoughFinal = 18,
        // Duplicate property Name found
        FinalInspection_19 = 19,
        // Duplicate property Name found
        RoughFinal_20 = 20,
        FireAlarm = 21,
        // Duplicate property Name found
        LowVoltage_22 = 22,
        // Duplicate property Name found
        LowVoltage_23 = 23,
        // Duplicate property Name found
        LowVoltage_24 = 24,
        // Duplicate property Name found
        LowVoltage_25 = 25,
        // Duplicate property Name found
        FinalInspection_26 = 26,
        // Duplicate property Name found
        Final_27 = 27,
        // Duplicate property Name found
        LowVoltage_28 = 28,
        // Duplicate property Name found
        RoughFinal_29 = 29,
        // Duplicate property Name found
        RoughFinal_30 = 30,
        // Duplicate property Name found
        RoughFinal_31 = 31,
        // Duplicate property Name found
        RoughFinal_32 = 32,
        RoughFinals = 33,
        // Duplicate property Name found
        RoughFinal_34 = 34,
        // Duplicate property Name found
        LowVoltage_35 = 35,
        LOWVOLTAGEFINAL = 36,
        // Duplicate property Name found
        LowVoltage_37 = 37,
        // Duplicate property Name found
        LowVoltage_38 = 38,
        // Duplicate property Name found
        RoughFinal_39 = 39,
        // Duplicate property Name found
        RoughFinal_40 = 40,
        // Duplicate property Name found
        RoughFinal_41 = 41,
        CancelPermit = 42,
        // Duplicate property Name found
        CancelPermit_43 = 43,
        // Duplicate property Name found
        CancelPermit_44 = 44,
        Fire = 45,
        // Duplicate property Name found
        RoughFinal_46 = 46,
        FinalElectricalInspection = 47,
        // Duplicate property Name found
        LowVoltage_48 = 48,
        // Duplicate property Name found
        LowVoltage_49 = 49,
        // Duplicate property Name found
        LowVoltage_50 = 50,
        // Duplicate property Name found
        LowVoltage_51 = 51,
        // Duplicate property Name found
        LowVoltage_52 = 52,
        // Duplicate property Name found
        LowVoltage_53 = 53,
        RoughAndFinalLowVolt = 54,
        RoughAndFinal = 55,
        // Duplicate property Name found
        CancelPermit_56 = 56,
        // Duplicate property Name found
        LowVoltage_57 = 57,
        // Duplicate property Name found
        LowVoltage_58 = 58,
        // Duplicate property Name found
        LowVoltage_59 = 59,
        Rough = 60,
        Sf = 61,
        // Duplicate property Name found
        Rough_62 = 62,
        // Duplicate property Name found
        Final_63 = 63,
        Asasasa = 64,
        Abc = 65,
        Num111 = 66,
        Asdfasdf = 67,
    }

export enum InspectionResultAllItems {
        Pass = 403,
        Fail = 404,
    }

export enum InspectionStatusAllItems {
        InspectionNeeded = 1,
        InspectionScheduled = 2,
        InspectionComplete = 3,
        OnHold = 4,
        Canceled = 5,
    }

export enum RoInspectionsAllItems {
        Num4793013233 = 1,
        Num4799578811 = 2,
        Num4799578116 = 3,
        // Duplicate property Name found
        Num4799578116_4 = 4,
        Num4798790947 = 5,
        Num4798797729 = 6,
        // Duplicate property Name found
        Num4798797729_7 = 7,
        // Duplicate property Name found
        Num4799578116_8 = 8,
        Num4793015430 = 9,
        Num4793017832 = 10,
        // Duplicate property Name found
        Num4793015430_11 = 11,
        // Duplicate property Name found
        Num4793015430_12 = 12,
        // Duplicate property Name found
        Num4799578116_13 = 13,
        Num4798795586 = 14,
        Num4794353288 = 15,
        Num4793018205 = 16,
        None = 17,
        // Duplicate property Name found
        None_18 = 18,
        Num4794812481 = 19,
        Num4798790108 = 20,
        Num4796444396 = 21,
        Num4794348392 = 22,
        // Duplicate property Name found
        Num4794348392_23 = 23,
        Num4792876467 = 24,
        Num4794355784 = 25,
        // Duplicate property Name found
        None_26 = 26,
        // Duplicate property Name found
        None_27 = 27,
        Num4792594650 = 28,
        // Duplicate property Name found
        None_29 = 29,
        // Duplicate property Name found
        None_30 = 30,
        // Duplicate property Name found
        None_31 = 31,
        Num4792594735 = 32,
        Num4798792926 = 33,
        // Duplicate property Name found
        None_34 = 34,
        // Duplicate property Name found
        Num4793018205_35 = 35,
        Num4799578136 = 36,
        Num4798793107 = 37,
        // Duplicate property Name found
        Num4793015430_38 = 38,
        // Duplicate property Name found
        Num4792594735_39 = 39,
        // Duplicate property Name found
        Num4793013233_40 = 40,
        // Duplicate property Name found
        Num4792594735_41 = 41,
        // Duplicate property Name found
        None_42 = 42,
        // Duplicate property Name found
        None_43 = 43,
        // Duplicate property Name found
        None_44 = 44,
        Num4798794318 = 45,
        Num4799576997 = 46,
        // Duplicate property Name found
        None_47 = 47,
        Num4798793264 = 48,
        Num4794348400 = 49,
        Num4796167723 = 50,
        // Duplicate property Name found
        Num4796167723_51 = 51,
        Num4793013161 = 52,
        // Duplicate property Name found
        Num4794348400_53 = 53,
        Num4799578160 = 54,
        // Duplicate property Name found
        None_55 = 55,
        // Duplicate property Name found
        None_56 = 56,
        // Duplicate property Name found
        None_57 = 57,
        Num4798793850 = 58,
        Num4798797805 = 59,
        // Duplicate property Name found
        None_60 = 60,
        // Duplicate property Name found
        None_61 = 61,
        Num8104472475 = 62,
        // Duplicate property Name found
        None_63 = 63,
        // Duplicate property Name found
        None_64 = 64,
        // Duplicate property Name found
        None_65 = 65,
        // Duplicate property Name found
        None_66 = 66,
        // Duplicate property Name found
        None_67 = 67,
    }

export enum InspectionStatusV2 {
        InspectionNeeded = 1,
        InspectionScheduled = 2,
        InspectionComplete = 3,
        OnHold = 4,
        Canceled = 5,
    }

// Excluding lookup Trust CodeValue All Items because it contains 416 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum CodeValueEquipmentDelivery {
        WeNeedDeliveredToSite = 130,
        WeNeedAQuoteFor = 132,
        WeWillPickUpAtBranch = 241,
    }

export enum CodeValuePayJobChangeStatus {
        Pending = 153,
        PendingManagerApproval = 154,
        PendingDepartmentHeadApproval = 155,
        PendingDivisionHeadApproval = 156,
        PendingExecutiveApproval = 157,
        Rejected = 158,
        Approved = 159,
    }

export enum CodeValuePayJobChangeDepartmentRole {
        DepartmentHead = 166,
        DivisionHead = 167,
    }

export enum CodeValueMemoOfRecordConclusion {
        Discussed = 16,
        VerbalWritten = 17,
        FinalWritten = 18,
        Termination = 19,
        DocumentationOnly = 20,
        PerformanceImprovementPlan = 21,
        Unsubstantiated = 196,
    }

export enum CodeValueMORStatus {
        Open = 194,
        Closed = 195,
    }

export enum CodeValueEmployeeTrainingNeeded {
        JobSetUp = 88,
        OCIPCCIP = 89,
        PrevailingWage = 90,
        BillingRequirements = 91,
        ChangeOrderManagement = 92,
        BISSubmission = 93,
        LaborApproval = 94,
        VendorPOs = 95,
        InvoiceApprovals = 96,
        CreditCardsExpenses = 97,
        Collections = 98,
        ForecastingAndWIP = 99,
        PayrollAndBurden = 100,
        LienWaivers = 101,
        SexualHarassmentAndHarassmentTraining = 102,
        DisciplinaryActionsHR208 = 103,
        PrevailingWageReporting = 104,
        // Duplicate property Name found
        OCIPCCIP_105 = 105,
        FMLAAndTheirResponsibilities = 106,
        BusinessProtectionAgreements = 107,
        EmployeeEvaluations = 116,
        EmployeeInterviews = 117,
        Safety = 118,
        OfferLetterAndExpectations = 119,
    }

export enum CodeValueEmployeeTrainingNeededConclusion {
        TrainingDelivered = 197,
        FurtherInformationNeeded = 198,
        MORNeeded = 199,
        NoIssueIdentified = 200,
    }

export enum CodeValueEmployeeTrainingNeededStatus {
        Open = 201,
        Closed = 202,
    }

export enum CodeValueAtFault {
        Yes = 208,
        No = 209,
        WordVsWord = 210,
    }

export enum CodeValueVechicleRepaired {
        Pending = 211,
        TotalLoss = 213,
        WillNotRepair = 214,
        Yes = 215,
    }

export enum CodeValueClaimStatus {
        Open = 216,
        Closed = 217,
        Pending = 218,
    }

export enum CodeValueInsuranceCompany {
        Allied = 219,
        Allstate = 220,
        AmericanFamily = 221,
        DirectAuto = 222,
        Encompass = 223,
        Esurance = 224,
        Farmers = 225,
        Geico = 226,
        LibertyMutual = 227,
        Metlife = 228,
        Nationwide = 229,
        PlymouthRock = 230,
        Progressive = 231,
        SafeAuto = 232,
        Safeco = 233,
        StateFarm = 234,
        TheHartford = 235,
        Travelers = 236,
        United = 237,
        USAA = 238,
        Zurich = 239,
        Other = 240,
        ArchInsurance = 405,
    }

export enum CodeValueTravelMode {
        Flight = 243,
        CarRental = 244,
        CompanyLoaner = 245,
        Other = 246,
    }

export enum CodeValueAirportPlan {
        LongTermParking = 256,
        DroppedOff = 257,
        UberLyftCab = 258,
        Other = 259,
    }

export enum CodeValueTransportationPlan {
        RentCar = 260,
        RentPassengerVan = 261,
        UberLyftCab = 262,
        Other = 263,
        RentTruckSUV = 266,
    }

export enum CodeValueLodgingPlan {
        BookedAheadByAdmin = 247,
        SpotAndStayWithCorpCC = 248,
        ClaimPerDiemHourlyStaffOnly = 249,
        Other = 250,
    }

export enum CodeValueTravelRequestStatus {
        Open = 264,
        Closed = 265,
    }

export enum CodeValueFiveStarRatingValue {
        Num1 = 267,
        Num2 = 268,
        Num3 = 269,
        Num4 = 270,
    }

// Excluding lookup Ethos_CodeValue All Items because it contains 1453 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum CodeValueEmsWorkStatus {
        Unassigned = 272,
        Temp = 273,
        Active = 274,
        AutoDispatch = 275,
        OnLend = 276,
        Probation = 277,
        MedicalLeave = 278,
        SickLeave = 279,
        Disability = 280,
        LimitedWorkRelease = 281,
        Suspended = 282,
        DoNotContactDNC = 283,
        PersonalTimeOffPTO = 284,
        Unavailable = 285,
        Remote = 286,
        Terminated = 287,
        Resigned = 289,
        Deceased = 290,
        Retired = 291,
    }

export enum CodeValueBodyPart {
        Head = 300,
        Eye = 301,
        Nose = 302,
        Mouth = 303,
        Neck = 304,
        BackUpper = 305,
        BackLower = 306,
        Chest = 307,
        Shoulder = 308,
        Arm = 309,
        Elbow = 310,
        Wrist = 311,
        Hand = 312,
        Finger = 313,
        Groin = 314,
        Hip = 315,
        Thigh = 316,
        Knee = 317,
        ShinCalf = 318,
        Ankle = 319,
        Foot = 320,
        Toe = 321,
    }

export enum CodeValueBodySide {
        Left = 298,
        Right = 299,
    }

export enum CodeValuePlenumOrRiser {
        NA = 103814,
        Plenum = 103815,
        Riser = 103816,
        Outdoor = 103817,
    }

export enum CodeValuePermitTeam {
        NA = 103826,
        NES = 103827,
        NSPLBU = 103828,
        OperationsSupport = 103829,
        Rollout = 103830,
        WEC = 103831,
        CRITICALPOWER = 103839,
    }

// Excluding lookup Ethos_CodeValueCustom All Items because it contains 10000 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum CodeValueEthosSkill {
        Construction = 103310,
        Electrical = 103311,
        FireAlarm = 103312,
        Network = 103313,
        OutsidePlant = 103314,
        Voice = 103315,
        Fiber = 103316,
        PhysicalSecurity = 103326,
        AV = 103347,
        BurglarAlarm = 103350,
        Controls = 103352,
        CCTV = 103357,
        AccessControl = 103358,
        DoorHardware = 103359,
        Rollouts = 103377,
        Service = 103378,
        Projects = 103379,
        Engineer = 103472,
        BankOfAmerica = 103518,
        Citibank = 103519,
        BICSI = 103520,
        Panduit = 103521,
        OSHA10 = 103522,
        OSHA30 = 103523,
        Crane = 103524,
        ScissorLift = 103525,
        BoomLift = 103526,
        Concrete = 103527,
        TrenchingBoring = 103528,
        AirMagnet = 103529,
        DataCenter = 103530,
        Costco = 103531,
        Kroger = 103532,
        WalMartService = 103539,
        Clerical = 103544,
        InstallationCombo = 103558,
        AlarmCCTV = 103559,
        CiscoVerikitCertified = 103563,
        BucketTruck = 103580,
        FieldNation = 103680,
        AnaerobicFiber = 103723,
        EERCS = 103772,
        BigComplex = 103773,
        LockOutTagOut = 103836,
        BootCampTechnician = 103837,
        BCTrainer = 103845,
        Industrial = 103853,
    }

export enum CodeValueWorkersCompClaimStatus {
        Open = 406,
        Closed = 407,
        Pending = 408,
        Denied = 409,
    }

export enum ChangeRequestAllItems {
        ChangeRequestId1 = 1,
        ChangeRequestId8 = 8,
        ChangeRequestId9 = 9,
        ChangeRequestId10 = 10,
        ChangeRequestId11 = 11,
        ChangeRequestId12 = 12,
        ChangeRequestId13 = 13,
        ChangeRequestId14 = 14,
        ChangeRequestId15 = 15,
        ChangeRequestId16 = 16,
        ChangeRequestId17 = 17,
        ChangeRequestId18 = 18,
        ChangeRequestId19 = 19,
        ChangeRequestId20 = 20,
        ChangeRequestId21 = 21,
        ChangeRequestId22 = 22,
        ChangeRequestId23 = 23,
        ChangeRequestId24 = 24,
        ChangeRequestId25 = 25,
        ChangeRequestId26 = 26,
        ChangeRequestId27 = 27,
        ChangeRequestId28 = 28,
        ChangeRequestId29 = 29,
        ChangeRequestId30 = 30,
        ChangeRequestId31 = 31,
        ChangeRequestId32 = 32,
        ChangeRequestId33 = 33,
        ChangeRequestId34 = 34,
        ChangeRequestId35 = 35,
        ChangeRequestId36 = 36,
        ChangeRequestId37 = 37,
        ChangeRequestId38 = 38,
        ChangeRequestId39 = 39,
        ChangeRequestId40 = 40,
        ChangeRequestId41 = 41,
        ChangeRequestId42 = 42,
        ChangeRequestId43 = 43,
        ChangeRequestId44 = 44,
        ChangeRequestId45 = 45,
        ChangeRequestId46 = 46,
    }

export enum EthosWachterDepartmentAllItems {
        WCSolutionDesignTeam = 3,
        WECElectricalManagement = 26,
        WECProjectsCommercial = 27,
        WECIndustrialPower = 28,
        WECService = 29,
        WECStJoeMO = 30,
        WECLowellARElectric = 31,
        WCExecutives = 32,
        NWRollout = 39,
        NWNationwideServiceProjects = 40,
        STFContractStaffing = 41,
        WCSales = 42,
        STPPhysicalSecurity = 44,
        INTLCanada = 45,
        INTLLeedsUK = 46,
        WCInformationTechnology = 47,
        INTLPuertoRico = 64,
        WCAccounting = 65,
        WCHumanResources = 66,
        WCOperations = 71,
        STPEmergingTechnologiesOLD = 74,
        STPSustainableEnergyOLD = 75,
        WCFacilities = 76,
        WECControls = 79,
        WTSNetworkEngineeringPrevious = 81,
        WTSPhysicalSecurityPrevious = 83,
        INTLCostaRica = 89,
        UKIreland = 91,
        UKLeedsUK = 92,
        LBUAtlantaGA = 93,
        LBUCharlotteNC = 94,
        LBUCincinnatiOH = 95,
        LBUColumbusOH = 96,
        LBUDallasTX = 97,
        LBUIrvineCA = 98,
        LBULenexaKS = 99,
        LBULowellAR = 100,
        LBUNashvilleTN = 101,
        LBUOrlandoFL = 102,
        LBUPhiladelphiaPA = 103,
        NWElectricalService = 104,
        LBUTulsaOK = 105,
        STPProfessionalServices = 106,
        WECDecaturIL = 107,
        WCITServices = 108,
        WECEngineering = 109,
        WECHoustonTX = 110,
        WSCWachterStaffingCorporate = 111,
        WECDallasTX = 112,
        WECColorado = 113,
        STFLBUStaffingCincinnatiLBU = 114,
        STFLBUStaffingNashvilleLBU = 115,
        WECIndustrialTechnology = 116,
        WECIndustrialNationwideProjects = 117,
        LBUDenverCO = 118,
        STFLBUStaffingAtlantaLBU = 119,
        STFLBUStaffingCharlotteLBU = 120,
        STFLBUStaffingDallasLBU = 121,
        STFLBUStaffingIrvineLBU = 122,
        STFLBUStaffingLowellLBU = 123,
        STFLBUStaffingPhiladelphiaLBU = 124,
        STFLBUStaffingSeattleLBU = 125,
        STFNWStaffingNSP = 126,
        STFNWStaffingRollout = 127,
        STFWECStaffingIndustrialPower = 128,
        STFWECStaffingIndustrialNationwideProjects = 129,
        STFWECStaffingIndustrialTech = 130,
        STFWECStaffingElectricService = 131,
        WTSIOT = 132,
        WECElectricalService = 133,
        LBUSeattleWA = 134,
        STFWCStaffingIT = 135,
        STFWCStaffingOperations = 136,
        STFWCStaffingHR = 137,
        WCRD = 138,
        LBUPhoenixAZ = 139,
        LBUSanJoseCA = 140,
        STFLBUStaffingSanJoseLBU = 141,
        STFWTSStaffingIOT = 142,
        STFWTSStaffingPhysicalSecurity = 143,
        STFWTSStaffingNetworkEngineering = 144,
        WTSWTSWAVE = 145,
        LBULBUSupport = 146,
        STFLBUStaffingLBUSupport = 147,
        STFWTSStaffingWAVE = 148,
        STFWCStaffingAccounting = 149,
        WTSIntegration = 160,
        WTSNetworkEngineering = 161,
        WTSPhysicalSecurity = 162,
        WTSProjectManagement = 163,
        WTSPurchasing = 164,
        WTSSolutionsEngineering = 165,
        WTSWarehouse = 166,
        WTSWTSManagement = 167,
        WTSHelpdesk = 168,
        STFLBUStaffingOrlandoLBU = 169,
    }

export enum WorkflowStatusPermitStatusDONOTUSE {
        NANoStatusAssigned = 694,
        INQInquiryOfPermitNecessityRequested = 695,
        NPRInquiryDeterminedNoPermitNeeded = 696,
        INFAdditionalInfoNeededFromPM = 697,
        PRQApplicationProcessRequestedToBegin = 698,
        AIPMunicipalityRequiresApplicationInPerson = 699,
        PAPPermitSuccessfullyAppliedFor = 700,
        PUMunicipalityRequiresPickUpInPerson = 701,
        POJMunicipalityRequiresPermitPostedOnSite = 702,
        RCVPermitReceived = 703,
        IRInspectionRequested = 704,
        ICInspectionComplete = 705,
        INInspectionNeeded = 707,
        CSNCorporateSupportNeeded = 710,
    }

export enum PermitStatusAllItems {
        NANoStatusAssigned = 694,
        INQInquiryOfPermitNecessityRequested = 695,
        NPRInquiryDeterminedNoPermitNeeded = 696,
        INFAdditionalInfoNeededFromPM = 697,
        PRQApplicationProcessRequestedToBegin = 698,
        AIPMunicipalityRequiresApplicationInPerson = 699,
        PAPPermitSuccessfullyAppliedFor = 700,
        PUMunicipalityRequiresPickUpInPerson = 701,
        POJMunicipalityRequiresPermitPostedOnSite = 702,
        RCVPermitReceived = 703,
        IRInspectionRequested = 704,
        ICInspectionComplete = 705,
        INInspectionNeeded = 707,
        CSNCorporateSupportNeeded = 710,
        CNLCanceled = 711,
        DWPWorkDoneWithoutPermit = 712,
        ISInspectionScheduled = 713,
    }

export enum CodeValueLicenseStatus {
        Pending = 150,
        Approved = 151,
        Rejected = 152,
        Closed = 336,
    }

export enum EthosWorkflowStatusSetAllItems {
        JobStatus = 1,
        JobBillingStatus = 2,
        JobSiteStatus = 3,
        JobSiteBillingStatus = 4,
        JobBISStatus = 5,
        CostBillingStatus = 6,
        TimesheetStatus = 7,
        UserStatus = 8,
        SubJobNumberStatus = 9,
        JobNumberStatus = 10,
        OpportunityStatus = 11,
        CustomerBillingInvoiceStatus = 12,
        SubJobRequestStatus = 13,
        SupportRequestStatus = 16,
        LastStatusBeforeClose = 17,
        PublicIssueStatus = 23,
        JobNumberChangeItemStatus = 26,
        SiteVerificationStatus = 28,
        AddressVerificationStatus = 29,
        CustomerAddressStatus = 30,
        CustomerStatus = 31,
        JobNumberForecastStatus = 32,
        JobNumberChangeRequestStatus = 33,
        ChangeOrderStatus = 34,
        AxIntegrationStatus = 35,
        Ro = 36,
        JobSubmittalStatus = 37,
        JobSubmittalDetailStatus = 38,
        SubmittalStatus = 39,
        CustomerCompanyStatus = 40,
        AccountPlanStatus = 41,
        ApprovalStatus = 42,
        HeatMapStatus = 43,
        InventoryOrderStatus = 44,
        ItemRequirementStatus = 45,
        CustomerCommissionStatus = 46,
        CommissionStatus = 47,
        InventoryItemStatus = 48,
        BillingCommissionStatus = 51,
        HardwareCommissionStatus = 52,
        JobNumberCommissionStatus = 54,
        JobNumberPhaseSubJobStatus = 55,
        JobNumberPhaseStatus = 56,
        JobNumberSubJobPhaseStatus = 57,
        CustomerStatusWs = 58,
        EndCustomerCompanyStatus = 59,
        TimesheetBatchStatus = 60,
        StockOrderStatus = 61,
        AddressChangeStatus = 64,
        ScheduleOfValueStatus = 65,
        DuplicateMergeCommitStatus = 66,
        CustomerAddressVerificationStatus = 67,
        AssetStatus = 68,
        VehicleStatus = 69,
        ProjectStatus = 70,
        PurchaseOrderStatus = 71,
        SendStatus = 72,
        TechnicianTravelStatus = 74,
        OpportunityLeadStatus = 75,
        OpportunityProposalStatus = 76,
        RevenueRecognitionVerificationStatus = 78,
        SurveyResponseStatus = 79,
        HistoricalStatus = 80,
        NotificationStatus = 81,
        LunchBreakViolationStatus = 88,
        ViolationStatus = 89,
        PermitStatus = 90,
        MMPTimesheetStatus = 91,
        BidStatus = 92,
        EstimatorStatus = 93,
        AdvancedPerDiemRequestStatus = 94,
        JobTaskStatus = 95,
    }

// Excluding lookup Ethos_WorkflowStatus All Items because it contains 443 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum EthosWorkflowStatusUserStatus {
        Pending = 314,
        Active = 315,
        Disabled = 316,
    }

// Excluding lookup Ethos_JobNumber - Active Only for Kickoff because it contains 7380 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum WorkflowStatusJobNumberStatus {
        Submitted = 322,
        Active = 323,
        Rejected = 324,
        Closed = 325,
        CloseoutRequested = 373,
        Reopened = 374,
        TransferPending = 386,
        SubmitToAX = 420,
        SubmittedToAX = 421,
        Cancelled = 575,
        Pending = 622,
    }

export enum CodeValuePermitStatus {
        New = 355,
        Researching = 356,
        OnHold = 357,
        ResearchSubmitted = 358,
        ApplicationPending = 359,
        PermitAppliedFor = 360,
        RequestComplete = 361,
        InspectionNeeded = 362,
        Canceled = 393,
        NoPermitNeeded = 395,
        NoPermitNeededWithExceptions = 396,
    }

export enum WorkflowStatusUserStatus {
        New = 310,
        Pending = 314,
        Active = 315,
        Disabled = 316,
    }

export enum PermitStatusV2 {
        New = 1,
        Researching = 2,
        RequestComplete = 3,
        ApplicationNeeded = 4,
        ApplicationPending = 5,
        PermitAppliedFor = 6,
        PermitReceived = 7,
        InspectionNeeded = 8,
        InspectionScheduled = 9,
        InspectionCompleted = 10,
        OnHold = 11,
        Canceled = 12,
    }

export enum CodeValueCompanyLicenseStatus {
        Active = 103818,
        Inactive = 103819,
    }

export enum WorkflowStatusOpportunityStatus {
        New = 326,
        InProgress = 327,
        Won = 328,
        Lost = 329,
        NoBid = 330,
        Evaluating = 335,
        Submitted = 336,
        OnHold = 337,
        Canceled = 338,
        Budget = 407,
        Lead = 523,
    }

export enum WorkflowStatusProjectStatus {
        Lead = 613,
        Active = 623,
        Closed = 656,
        New = 662,
        Evaluating = 663,
        InProgress = 664,
        BidSubmitted = 665,
    }




